/*
 * Генератор клипов — страница платного токенного лейна.
 *
 * ⚠️ Прогон ДОЛГИЙ (минуты, пятиминутный клип — до тринадцати). Отсюда решения,
 * которые нельзя убирать:
 *   1. страница переживает уход: идущая генерация подхватывается при
 *      возвращении (история тула → статус по id), готовая — в «Моих клипах»
 *      и «Моих генерациях». «Не закрывайте вкладку» мы не пишем;
 *   2. прогресс идёт от ЧАСОВ, а не от ответов сервера: воркер не рапортует
 *      проценты, а стоящая полоса читается как поломка (жалоба #1526);
 *   3. проба сцены — отдельная кнопка со СВОЕЙ ценой (решение Фарида 04.09);
 *   4. ПЕСНЯ задаёт окно клипа, места склеек и части (song.js, parts.js);
 *   5. деньги называются ДО нажатия и в валюте (≈ 248 ₽), нехватка — тоже;
 *      «Пополнить» открывает кассу ЗДЕСЬ (token-wall.js).
 *
 * Переделка 24.10.2026 (шапка блейда): композер с таблетками, стиль картинками,
 * галерея примеров в экране сцены, раскадровка по частям песни, окно клипа
 * (короткая версия / Canvas / свой отрезок), пульс под музыку, 1080p и 24 к/с
 * для Премиума, «Мои клипы», возврат к идущему прогону, «Тот же образ» —
 * настоящий переключатель.
 */
import { analyseSong, attachBeats, bestBars, barSeconds, fmtClock, energyProfile, sceneCutsWindow, reactCurve, cutsToPlan } from './song.js';
import { analyseParts, partCuts, bestHighlight } from './parts.js';
import { mountTimeline, render as renderTimeline, playhead } from './timeline.js';
import { mountLibrary, loadLibrary, prepend as libPrepend, update as libUpdate, markActive as libMark } from './library.js';
import { mountDraft } from './draft.js';
import { mountSinger, paintSinger } from './singer.js';
import { mountLyrics, lyrState, linesForTimeline, lineAt, drawLyrics, attachOverlay, setOverlay, onSongChanged as lyrSongChanged,
    loadSaved as lyrLoadSaved, attachTo as lyrAttachTo, paintPanel as lyrPaint, ensureLibs as lyrLibs,
    exportWork as lyrExport, importWork as lyrImport, clearWork as lyrClear, textBetween as lyrTextBetween, textStartingIn as lyrTextStarting } from './lyrics.js';
import { mountBoard, paintBoard, focusSelection, boardSeed, exportStills, importStills, clearStills } from './board.js';

const $ = (id) => document.getElementById(id);
const CG = window.__CG || { i18n: {}, urls: {}, price: {}, cadence: {} };
const I = CG.i18n || {}, U = CG.urls || {};
const PRICE = CG.price || { base: 1000, per: 50, min: 3, max: 300, preview: 0 };
const CAD = CG.cadence || { min: 4, max: 15, bars: [2, 4, 8] };
const SLUG = 'clip-generator';
const GEN_FPS = 12;

/**
 * Во сколько раз генерация длиннее самого клипа. ⚠️ Замер ПРОДА (24–25.10.2026,
 * шесть готовых клипов: 108 с → 378–414 с, 180 с → 718 с, 216 с → 756 с): 3.5–4.5×,
 * медиана 3.8 — воркер на проде даёт 0.27–0.29 с на кадр против 0.17–0.2 стенда.
 * Здесь стояли 2.4 со стенда, и страница обещала «около 8 мин» клипу, который
 * шёл 13.
 */
/* С 26.10 числа — из config/ai-video.php → speed (одна правда с ClipQueue
   на сервере); здесь — запас на случай страницы из старого кэша. */
const SPEED = CG.speed || {};
const REALTIME_FACTOR = +SPEED.realtime_factor || 3.8;
/** Холодный старт прогретого воркера — ~2.5 мин (замер 04.09). */
const COLD_START_S = +SPEED.cold_start_s || 150;
const REDO = CG.redo || { enabled: false, base: 400, per: 100, multi: false, max: 12 };
// Черновик описаний по тексту песни (ClipSceneDraft): цена — за выданный черновик.
const DRAFT = CG.draft || { enabled: false, tokens: 0 };
let draftBusy = false;
/** Поющий персонаж (ClipSinger): цена и ожидание — числа сервера. */
const SINGER = CG.singer || { enabled: false };
/** Проба — короткий шот; воркер обычно уже тёплый после первой. */
const PREVIEW_ETA_S = 60;

const csrf = () => (document.querySelector('meta[name="csrf-token"]') || {}).content || '';
const tr = (key, map) => {
    let s = I[key] || '';
    if (map) for (const k in map) s = s.split(':' + k).join(String(map[k]));
    return s;
};

const state = {
    style: null, look: null, aspect: null, ratio: '9:16', ar: '9/16', arn: '0.5625',
    seconds: 180, cadenceS: 8, bars: 4, peakFaster: true,
    react: 0, res: 720, fps: 12, canvas: false,
    song: null, songUrl: null, buffer: null, parts: null,
    win: { kind: 'whole', from: 0, to: 0 },
    image: null,
    cuts: [0],
    sceneText: [],            // [{t: момент ТРЕКА/клипа начала сцены, text}]
    partText: {},             // буква → описание
    occText: [],              // [{t: начало ПОВТОРА части, text}] — повтор «только здесь» (чат 729)
    sceneSeed: [],            // [{t: начало сцены, seed}] — свой сид сцены из раскадровки
    selected: null,
    lastSeed: null, keepSeed: false,
    live: false, authed: false, pro: false, balance: null, locked: 0, money: CG.money || null,
    id: null, timer: null, startedAt: 0, etaS: 0, lastUrl: null, lastId: null,
    resultHasSong: false, resultFrom: 0, resultSeconds: 0, outBlob: null,
    serverAudio: false, lastDl: null, songSent: new Set(),
    shown: 'gallery', exampleKey: null, exPromptInserted: null,
    busy: false, promptTyped: false, ideaAt: -1,
    sessionIds: new Set(),
    // Очередь и фаза идущего прогона — от сервера (ClipQueue), не от часов.
    queue: null, queueAt: 0, barMax: 0, waitKind: 'clip',
    // Показанный клип: его песня, сцены, слова человека по сценам, пересъёмка.
    resultSong: null, resultScenes: [], resultShotsSrc: [], resultPrompt: '',
    canRedo: false, redoWhy: null, redoScene: 0, redoOf: null, outSig: '',
    singWhy: 'disabled', proUrl: '', resultAspect: '',
};

/* ────────────────────────────────────────────────────────────── приборы ── */
/** «Мои работы» композера (draft.js) — null, пока не смонтирован или без хранилища. */
let draft = null;
const funnel = (stage, data) => { try { window.__aeFunnel && window.__aeFunnel(stage, data || {}); } catch (_) { /* прибор не роняет тул */ } };
const stageT = (name, meta) => { try { window.__stage && window.__stage(name, meta || {}); } catch (_) { /* — */ } };
const critical = (type, data) => { try { window.__aeCritical && window.__aeCritical(type, data || {}); } catch (_) { /* — */ } };
const save = (k, v) => { try { window.__toolSettings && window.__toolSettings.save(SLUG, k, v); } catch (_) { /* — */ } };
const load = (k, d) => { try { return window.__toolSettings ? window.__toolSettings.load(SLUG, k, d) : d; } catch (_) { return d; } };

/* ────────────────────────────────────────────────────────── мелочи ──── */
const fmtMin = (s) => Math.max(1, Math.round(s / 60));
const fmtNum = (n) => { try { return Number(n).toLocaleString(window.__intlLocale ? window.__intlLocale() : undefined); } catch (_) { return String(n); } };

function tokensFor(seconds) {
    const s = Math.max(PRICE.min, Math.min(PRICE.max, Math.ceil(seconds)));
    return PRICE.base + Math.round(s * PRICE.per);
}
function moneyFor(tokens) {
    const m = state.money;
    if (!m || !(m.rate > 0)) return '';
    const amount = tokens * m.rate;
    const decimals = (typeof m.decimals === 'number') ? m.decimals : 0;
    let n;
    try { n = amount.toLocaleString(window.__intlLocale ? window.__intlLocale() : undefined, { minimumFractionDigits: decimals, maximumFractionDigits: decimals }); }
    catch (_) { n = amount.toFixed(decimals); }
    return (m.pos === 'after') ? (n + (m.symbol || '')) : ((m.symbol || '') + n);
}

function msg(text, kind) {
    const el = $('cgMsg');
    if (!el) return;
    if (!text) { el.hidden = true; el.textContent = ''; return; }
    el.className = 'tc-msg' + (kind ? ' ' + kind : '');
    el.textContent = text;
    el.hidden = false;
}
function status(text) {
    const el = $('cgStatus');
    if (!el) return;
    el.textContent = text || '';
    el.hidden = !text;
}
function setBusy(on) {
    state.busy = !!on;
    ['cgGo', 'cgPreview'].forEach((id) => { const b = $(id); if (b) b.disabled = state.busy; });
}
function radio(box, attr, value) {
    if (!box) return;
    box.querySelectorAll('[data-' + attr + ']').forEach((b) => {
        const on = String(b.dataset[attr.replace(/-([a-z])/g, (m, c) => c.toUpperCase())]) === String(value);
        b.classList.toggle('on', on);
        b.setAttribute('aria-checked', on ? 'true' : 'false');
    });
}
function closePop(id) {
    const p = $(id);
    if (p && window.__anchoredPopover) { try { window.__anchoredPopover.close(p); } catch (_) { /* — */ } }
}
/** «⋯» у результата видна, только когда в меню есть хоть одно действие. */
function paintMore() {
    const more = $('cgMore'), pop = $('cgPopMore');
    if (!more || !pop) return;
    more.hidden = ![...pop.querySelectorAll('.cg-menu-i')].some((b) => !b.hidden);
}
function stageSwap(fn) {
    if (window.__viewTransition) { window.__viewTransition(fn); return; }
    fn();
}

/* ══════════════════════════════════════════════════════ ТАБЛЕТКИ ══════ */

function lenLabel(s) {
    s = Math.round(s);
    return s < 60 ? s + ' ' + (I.sec_short || 's') : fmtClock(s);
}

function refreshPills() {
    // Камера
    const camIcon = $('cgCamIcon');
    if (camIcon && CG.camIcons && CG.camIcons[state.style]) camIcon.innerHTML = CG.camIcons[state.style];
    const camV = $('cgCamV');
    if (camV) camV.textContent = I['style_' + state.style] || state.style;
    // Формат
    const fmtV = $('cgFmtV'), fmtI = $('cgFmtIcon');
    if (fmtV) fmtV.textContent = state.canvas ? 'Canvas' : state.ratio;
    if (fmtI) fmtI.style.setProperty('--i-ar', state.ar);
    $('cgPillFmt') && $('cgPillFmt').classList.toggle('lit', state.canvas);
    // Длина
    const lenV = $('cgLenV');
    if (lenV) {
        if (!state.song) lenV.textContent = lenLabel(state.seconds);
        else if (state.win.kind === 'whole') lenV.textContent = lenLabel(state.seconds);
        else lenV.textContent = fmtClock(state.win.from) + '–' + fmtClock(state.win.to);
    }
    $('cgPillLen') && $('cgPillLen').classList.toggle('lit', !!state.song && state.win.kind !== 'whole');
    // Смена сцен
    const cutV = $('cgCutV');
    if (cutV) cutV.textContent = state.song ? ((I.cadence_bars && I.cadence_bars[state.bars]) || state.bars) : (state.cadenceS + ' ' + (I.sec_short || 's'));
    // Пульс
    const mV = $('cgMotionV');
    if (mV) mV.textContent = state.react >= 1 ? (I.motion_strong || '') : (state.react > 0 ? (I.motion_soft || '') : (I.motion_off || ''));
    $('cgPillMotion') && $('cgPillMotion').classList.toggle('lit', state.react > 0 && !!state.song);
    const need = $('cgMotionNeedSong');
    if (need) need.hidden = !!state.song;
    // Текст песни
    const ls = lyrState();
    const lyV = $('cgLyrV');
    if (lyV) lyV.textContent = ls.aligning ? (I.lyr_v_aligning || '…') : (!ls.count ? (I.lyr_v_none || '')
        : (ls.timed ? tr(ls.shown ? 'lyr_v_on' : 'lyr_v_hidden', { n: ls.count }) : tr('lyr_v_lines', { n: ls.count })));
    $('cgPillLyr') && $('cgPillLyr').classList.toggle('lit', ls.shown);
    // Качество
    const qV = $('cgQualV');
    if (qV) qV.textContent = (state.res >= 1080 ? '1080p' : '720p') + (state.fps >= 24 ? ' · ' + (I.fps_24_short || '24') : '');
    $('cgPillQual') && $('cgPillQual').classList.toggle('lit', state.res >= 1080 || state.fps >= 24);
}

/** Цены в списках длины — каждый вариант называет свою. */
function refreshOptionPrices() {
    document.querySelectorAll('[data-price-for]').forEach((el) => {
        el.textContent = fmtNum(tokensFor(+el.dataset.priceFor));
    });
    if (state.song) {
        const w = windowsFor();
        document.querySelectorAll('[data-price-win]').forEach((el) => {
            const k = el.dataset.priceWin;
            el.textContent = w[k] ? fmtNum(tokensFor(w[k].to - w[k].from)) : '';
        });
        const wv = $('cgWinWholeV'), pv = $('cgWinPeakV');
        if (wv) wv.textContent = tr('win_whole_v', { len: fmtClock(w.whole.to - w.whole.from) });
        if (pv) pv.textContent = w.peak ? tr('win_peak_v', { from: fmtClock(w.peak.from), to: fmtClock(w.peak.to) }) : '';
    }
    document.querySelectorAll('[data-bars-sec]').forEach((el) => {
        const s = state.song ? barSeconds(state.song, +el.dataset.barsSec) : 0;
        el.textContent = s ? '≈ ' + s.toFixed(1) + ' ' + (I.sec_short || 's') : '';
    });
}

/* ══════════════════════════════════════════════════ ОКНО И СЦЕНЫ ═════ */

/** Окна клипа на треке по видам. */
function windowsFor() {
    const dur = state.song ? state.song.duration : 0;
    const out = { whole: { from: 0, to: Math.min(dur, PRICE.max) } };
    const parts = state.parts && state.parts.parts;
    const hl = parts ? bestHighlight(parts, 60) : null;
    let peakFrom = 0;
    if (hl && hl.t1 - hl.t0 >= 8) {
        out.peak = { from: hl.t0, to: Math.min(dur, Math.max(hl.t1, hl.t0 + 15)) };
        peakFrom = hl.t0;
    } else if (state.song && state.song.energy && state.song.energy.e.length) {
        // Частей нет — самое громкое окно в 30 с по огибающей.
        const { t, e } = state.song.energy;
        let best = 0, bestAt = 0;
        for (let i = 0; i < t.length; i++) {
            let acc = 0, n = 0;
            for (let j = i; j < t.length && t[j] < t[i] + 30; j++) { acc += e[j]; n++; }
            if (n && acc / n > best && t[i] + 30 <= dur) { best = acc / n; bestAt = t[i]; }
        }
        peakFrom = bestAt;
        out.peak = { from: bestAt, to: Math.min(dur, bestAt + 30) };
    }
    out.short = { from: peakFrom, to: Math.min(dur, peakFrom + 30) };
    out.canvas = { from: peakFrom, to: Math.min(dur, peakFrom + 8) };
    return out;
}

/** Ближайшая доля — край окна попадает в музыку, а не в середину удара. */
function snapToBeat(t) {
    const beats = (state.song && state.song.beats) || [];
    let best = t, d = 0.45;
    for (const b of beats) { const x = Math.abs(b - t); if (x < d) { d = x; best = b; } }
    return best;
}

function setWindow(from, to, kind, final) {
    const dur = state.song.duration;
    from = Math.max(0, Math.min(from, dur - PRICE.min));
    to = Math.max(from + PRICE.min, Math.min(to, dur));
    if (to - from > PRICE.max) to = from + PRICE.max;
    if (final) {
        const f2 = snapToBeat(from), t2 = snapToBeat(to);
        if (t2 - f2 >= PRICE.min && t2 - f2 <= PRICE.max) { from = f2; to = t2; }
    }
    state.win = { kind: kind || 'custom', from, to };
    state.seconds = to - from;
    radio($('cgWindow'), 'win', state.win.kind);
    replan();
}

/** Пересчитать сцены, цену, шкалу. */
function replan() {
    const lim = { min: CAD.min, max: CAD.max, peakFaster: state.peakFaster };
    if (state.song) {
        const { from, to } = state.win;
        if (state.parts && state.parts.parts.length > 1) {
            state.cuts = partCuts(state.parts.bars, state.parts.parts, state.bars, from, to, lim);
        } else {
            state.cuts = sceneCutsWindow(state.song, state.bars, from, to, lim).cuts;
        }
        state.cadenceS = Math.max(CAD.min, Math.min(CAD.max, state.seconds / Math.max(1, state.cuts.length)));
    } else {
        const n = Math.max(1, Math.ceil(state.seconds / state.cadenceS - 1e-6));
        state.cuts = [];
        for (let k = 0; k < n; k++) state.cuts.push(+(k * state.cadenceS).toFixed(3));
    }
    if (state.selected && state.selected.kind === 'scene' && state.selected.index >= state.cuts.length) state.selected = null;
    state.etaS = COLD_START_S + state.seconds * REALTIME_FACTOR;
    refreshPills();
    refreshCost();
    refreshOptionPrices();
    paintTimeline();
}

/* Описания сцен держатся за МОМЕНТ начала, а не за номер: при смене окна или
   шага номера сдвигаются, а момент — нет. */
function sceneAbsStart(i) { return (state.song ? state.win.from : 0) + (state.cuts[i] || 0); }
function sceneTextAt(i) {
    const t = sceneAbsStart(i);
    const hit = state.sceneText.find((x) => Math.abs(x.t - t) < 0.6);
    return hit ? hit.text : '';
}
function setSceneText(i, text) {
    const t = sceneAbsStart(i);
    state.sceneText = state.sceneText.filter((x) => Math.abs(x.t - t) >= 0.6);
    if (text.trim()) state.sceneText.push({ t, text });
}
function partOfScene(i) {
    if (!state.parts || !state.song) return null;
    const t = sceneAbsStart(i) + 0.05;
    const p = state.parts.parts.find((q) => t >= q.t0 && t < q.t1);
    return p ? p.label : null;
}
function promptForScene(i) {
    const own = sceneTextAt(i);
    if (own) return own;
    // Повтор части «только здесь» (чат 729: разные куплеты под одной буквой) —
    // своё описание, даже пустое: тогда сцена берёт общее, а не чужой куплет.
    const occ = occOfScene(i);
    if (occ && isUnlinked(occ.t0)) return occTextAt(occ.t0);
    const l = occ ? occ.label : null;
    return (l && state.partText[l]) ? state.partText[l] : '';
}
/** Повтор части, в котором начинается сцена i (абсолютные t0/t1), или null. */
function occOfScene(i) {
    if (!state.parts || !state.song) return null;
    const t = sceneAbsStart(i) + 0.05;
    return state.parts.parts.find((q) => t >= q.t0 && t < q.t1) || null;
}
const nearT = (a, b) => Math.abs(a - b) < 0.6;
function occEntry(t0) { return state.occText.find((x) => nearT(x.t, t0)) || null; }
function isUnlinked(t0) { return !!occEntry(t0); }
function occTextAt(t0) { const e = occEntry(t0); return e ? e.text : ''; }
function setOccText(t0, text) {
    const e = occEntry(t0);
    if (e) e.text = text; else state.occText.push({ t: t0, text });
    paintTimeline();
}
/** «Во всех повторах»: повтор снова берёт описание части. */
function linkOcc(t0) {
    state.occText = state.occText.filter((x) => !nearT(x.t, t0));
    funnel('occ_link', { all: 1 });
    paintTimeline();
}
/** «Только здесь»: повтор получает своё описание — стартом служит описание части. */
function unlinkOcc(t0) {
    if (!occEntry(t0)) {
        const pt = state.parts && state.parts.parts.find((q) => nearT(q.t0, t0));
        state.occText.push({ t: t0, text: pt ? (state.partText[pt.label] || '') : '' });
    }
    funnel('occ_link', { all: 0 });
    paintTimeline();
}
function sceneSeedAt(i) {
    const t = sceneAbsStart(i);
    const hit = state.sceneSeed.find((x) => nearT(x.t, t));
    return hit ? hit.seed : null;
}
function setSceneSeed(i, seed) {
    const t = sceneAbsStart(i);
    state.sceneSeed = state.sceneSeed.filter((x) => !nearT(x.t, t));
    if (seed !== null && seed !== undefined) state.sceneSeed.push({ t, seed });
}
/* Обложка — по ЛИЧНОСТИ файла: та же картинка, выбранная заново, — тот же кадр. */
const imgIds = new WeakMap();
let imgSeq = 0;
function imgId(b) { if (!b) return 0; if (!imgIds.has(b)) imgIds.set(b, ++imgSeq); return imgIds.get(b); }
/** Всё, кроме описания и сида сцены, что делает её первый кадр иным: при смене кадры уходят. */
function compositionSig() {
    return JSON.stringify([state.style, state.look, state.aspect, state.cuts.map((c) => Math.round(c * 100)),
        state.song ? Math.round(state.win.from * 100) : 0, Math.round(state.seconds * 100), imgId(state.image)]);
}
/** Модель доски сцен (board.js): сцены, повторы частей, строки песни. */
function boardModel() {
    const from = state.song ? state.win.from : 0;
    const main = (($('cgPrompt') || {}).value || '').trim();
    const reps = {};
    ((state.parts && state.parts.parts) || []).forEach((q) => { reps[q.label] = (reps[q.label] || 0) + 1; });
    const parts = (state.parts && state.song)
        ? state.parts.parts.filter((q) => q.t1 > from + 0.05 && q.t0 < from + state.seconds - 0.05) : [];
    const scenes = state.cuts.map((c, i) => {
        const to = i + 1 < state.cuts.length ? state.cuts[i + 1] : state.seconds;
        const occ = occOfScene(i);
        const own = sceneTextAt(i);
        const eff = promptForScene(i);
        return {
            i, from: c, to, abs: from + c, label: occ ? occ.label : null, occT0: occ ? occ.t0 : null,
            own, inherited: own ? '' : (eff || main), effective: eff || main,
            lyric: state.song ? lyrTextBetween(from + c, from + to) : '',
        };
    });
    // Доска — когда есть что описывать (песня, описание, свои тексты сцен) и
    // экран занят композицией, а не готовым клипом или прогоном.
    const work = !!(state.song || main.length >= 3 || state.sceneText.length
        || Object.values(state.partText).some((x) => x && x.trim()));
    return {
        visible: work && state.shown !== 'result' && state.shown !== 'progress',
        aspect: state.aspect, scenes,
        parts: parts.map((q) => ({
            label: q.label, t0: q.t0, t1: q.t1, repeats: reps[q.label] || 1,
            text: state.partText[q.label] || '', occText: occTextAt(q.t0), unlinked: isUnlinked(q.t0),
            lyric: lyrTextBetween(Math.max(q.t0, from), Math.min(q.t1, from + state.seconds)),
        })),
    };
}

function paintTimeline() {
    const withText = new Set();
    state.cuts.forEach((_, i) => { if (sceneTextAt(i)) withText.add(i); });
    const partsWithText = new Set(Object.keys(state.partText).filter((k) => state.partText[k]));
    renderTimeline({
        songDuration: state.song ? state.song.duration : 0,
        from: state.song ? state.win.from : 0,
        to: state.song ? state.win.to : state.seconds,
        clipSeconds: state.seconds,
        cuts: state.cuts,
        parts: (state.parts && state.parts.parts) || [],
        energy: state.song ? state.song.energy : null,
        selected: state.selected,
        scenesWithText: withText,
        partsWithText,
        windowEditable: !!state.song,
        lyrics: linesForTimeline(),
    });
    const title = $('cgTlTitle'), sub = $('cgTlSub'), hint = $('cgTlHint');
    const n = state.cuts.length;
    if (title) title.textContent = tr('tl_title', { n });
    if (sub) {
        const every = state.seconds / Math.max(1, n);
        let s = tr('tl_every', { s: every.toFixed(1) });
        if (state.song && state.win.kind !== 'whole') s += ' · ' + tr('tl_window', { from: fmtClock(state.win.from), to: fmtClock(state.win.to) });
        sub.textContent = s;
    }
    if (hint) hint.textContent = state.song ? (I.tl_hint_song || '') : (I.tl_hint || '');
    const listen = $('cgListen');
    if (listen) listen.hidden = !state.songUrl;
    paintBoard();
    paintDraft();
}

function select(sel, from) {
    state.selected = sel;
    paintTimeline();
    // Выбор на шкале — карточка в поле зрения доски (сама доска выбрала — уже там).
    if (from !== 'board') focusSelection(sel);
    if (sel && sel.kind === 'part' && state.parts) {
        funnel('part_select', { label: sel.label });
    } else if (sel) {
        funnel('scene_select', { i: sel.index });
    }
}

/* ══════════════════════════════════════════════════════ ЦЕНА И КОШЕЛЁК ═ */

function refreshCost() {
    const tokens = tokensFor(state.seconds);
    const gp = $('cgGoPrice');
    if (gp) gp.textContent = fmtNum(tokens);
    const c = $('cgCost');
    if (c) {
        c.textContent = '';
        const money = moneyFor(tokens);
        const b = document.createElement('b');
        b.textContent = tr('cost_hint', { n: fmtNum(tokens) });
        c.append(b);
        if (money) c.append(' ' + tr('cost_money', { n: money }));
        c.append(' · ' + tr('eta_hint', { n: fmtMin(state.etaS) }));
    }
    refreshWallet();
}

/**
 * Кошелёк — вслух и ДО нажатия. Кнопка при этом НЕ выключается: выключенная
 * кнопка молчит о причине, а нажатие на живую приходит в тот же ответ, что и
 * строка над ней.
 */
function refreshWallet() {
    const box = $('cgWallet'), text = $('cgWalletText');
    const topup = $('cgTopup'), login = $('cgLogin'), reg = $('cgRegister');
    if (!box || !text) return;
    const need = tokensFor(state.seconds);
    box.classList.remove('short');
    [topup, login, reg].forEach((a) => { if (a) a.hidden = true; });
    if (!state.authed) {
        text.textContent = I.login_line || '';
        if (login) login.hidden = false;
        if (reg) reg.hidden = false;
        box.hidden = !text.textContent;
        return;
    }
    if (typeof state.balance !== 'number') { box.hidden = true; return; }
    const bal = state.balance;
    if (bal < need) {
        const short = need - bal;
        const money = moneyFor(short);
        text.textContent = tr('short_line', { n: fmtNum(short) }) + (money ? ' ' + tr('short_money', { n: money }) : '');
        // Лежит, но сюда не идёт (подаренный Премиум) — называем вслух: иначе
        // «не хватает» спорит с балансом в боковой панели и в кассе (conv 718).
        if (state.locked > 0) text.textContent += ' · ' + tr('balance_locked', { n: fmtNum(state.locked) });
        box.classList.add('short');
        if (topup) { topup.hidden = false; topup.setAttribute('data-tmb-short', String(short)); }
    } else {
        const money = moneyFor(bal);
        text.textContent = tr('balance', { n: fmtNum(bal) }) + (money ? ' ' + tr('balance_money', { n: money }) : '');
    }
    box.hidden = false;
}

function setBalance(n) { state.balance = n; refreshWallet(); }

/* ══════════════════════════════════════════════════════════ ПЕСНЯ ════ */

async function onSong(file, buffer) {
    if (!file || !buffer) return;
    status(I.song_reading || '');
    const line = $('cgSongLine');
    if (line) { line.hidden = false; line.textContent = I.song_reading || ''; }
    try {
        state.song = analyseSong(file, buffer);
        await attachBeats(state.song, buffer);
        state.song.energy = energyProfile(buffer, state.song.beats, state.song.duration);
    } catch (_) {
        state.song = null;
        status('');
        if (line) line.hidden = true;
        msg(I.song_failed || I.error_generic, 'warn');
        critical('clip_song_unreadable', { name: file.name, size: file.size });
        if (draft) draft.songFailed();
        return;
    }
    state.buffer = buffer;
    try { if (state.songUrl) URL.revokeObjectURL(state.songUrl); } catch (_) { /* — */ }
    try { state.songUrl = URL.createObjectURL(file); } catch (_) { state.songUrl = null; }

    // Части песни — по повторам. Ошибка разбора не роняет песню: сцены пойдут
    // по долям, как раньше.
    state.parts = null;
    try {
        const ch = [];
        for (let c = 0; c < buffer.numberOfChannels; c++) ch.push(buffer.getChannelData(c));
        const yieldEvery = () => new Promise((r) => setTimeout(r, 0));
        const t0 = performance.now();
        const parts = await analyseParts({ channels: ch, sampleRate: buffer.sampleRate, duration: buffer.duration }, state.song.beats, { yieldEvery });
        state.parts = parts;
        funnel('song_parts', { n: parts.parts.length, labels: parts.labels.length, ms: Math.round(performance.now() - t0) });
    } catch (e) {
        critical('clip_parts_failed', { msg: String((e && e.message) || e).slice(0, 80) });
    }

    document.querySelectorAll('#cgCadence .cg-cad-bars').forEach((b) => { b.hidden = false; });
    document.querySelectorAll('#cgCadence .cg-cad-secs').forEach((b) => { b.hidden = true; });
    $('cgPeakFasterRow') && ($('cgPeakFasterRow').hidden = !(state.parts && state.parts.parts.length > 1));
    $('cgLength') && ($('cgLength').hidden = true);
    $('cgWindow') && ($('cgWindow').hidden = false);
    state.bars = bestBars(state.song, CAD.bars, { min: CAD.min, max: CAD.max });
    radio($('cgCadence'), 'bars', state.bars);

    state.partText = {};
    state.sceneText = [];
    state.occText = [];
    state.sceneSeed = [];
    state.selected = null;
    const w = windowsFor();
    if (state.canvas) setWindow(w.canvas.from, w.canvas.to, 'canvas', true);
    else setWindow(w.whole.from, w.whole.to, 'whole', false);
    status('');
    songLine();
    lyrSongChanged();
    // Открыт клип этой песни (вернулся позже, «Мои клипы») — теперь он
    // скачивается с музыкой и словами.
    if (state.shown === 'result' && !state.resultHasSong && songMatches(state.resultSong)) {
        state.resultHasSong = true;
        state.resultFrom = +state.resultSong.from || 0;
        state.outBlob = null;
        refreshResultSong();
        funnel('song_reattached', { id: state.lastId });
        if (!state.serverAudio) sendSong(state.lastId);
    }
    // Идущий клип этой песни (вернулся во время отрисовки, песня приехала после).
    if (state.busy && state.id && songMatches(state.runningSong)) sendSong(state.id);
    stageT('song_loaded');
    funnel('song_loaded', {
        bpm: Math.round(state.song.bpm), beats: state.song.beats.length,
        dur: Math.round(state.song.duration), scenes: state.cuts.length,
        parts: state.parts ? state.parts.parts.length : 0,
    });
    if (draft) draft.songReady(file);
}

function songLine() {
    const line = $('cgSongLine');
    if (!line || !state.song) return;
    const s = state.song;
    const tpl = s.bpm ? (I.song_line || '') : (I.song_line_nobpm || '');
    let text = tpl.split(':len').join(fmtClock(s.duration)).split(':bpm').join(String(Math.round(s.bpm)));
    const nParts = state.parts ? state.parts.parts.length : 0;
    const nLabels = state.parts ? state.parts.labels.length : 0;
    text += ' ' + (nParts > 1 ? tr('parts_found', { n: nParts, k: nLabels }) : (I.parts_none || ''));
    if (s.duration > PRICE.max + 0.5) text += ' ' + tr('song_trimmed', { len: fmtClock(PRICE.max) });
    line.textContent = text;
    line.hidden = false;
}

function dropSong() {
    listenStop();
    state.song = null; state.parts = null; state.buffer = null;
    try { if (state.songUrl) URL.revokeObjectURL(state.songUrl); } catch (_) { /* — */ }
    state.songUrl = null;
    $('cgSongLine') && ($('cgSongLine').hidden = true);
    document.querySelectorAll('#cgCadence .cg-cad-bars').forEach((b) => { b.hidden = true; });
    document.querySelectorAll('#cgCadence .cg-cad-secs').forEach((b) => { b.hidden = false; });
    $('cgPeakFasterRow') && ($('cgPeakFasterRow').hidden = true);
    $('cgLength') && ($('cgLength').hidden = false);
    $('cgWindow') && ($('cgWindow').hidden = true);
    state.partText = {}; state.sceneText = []; state.occText = []; state.sceneSeed = []; state.selected = null;
    const active = document.querySelector('#cgLength .cg-opt.on');
    state.seconds = active ? +active.dataset.seconds : 180;
    replan();
    songAudio(false);
    funnel('song_removed', {});
}

/* ── «Слушать» с выбранного места + синхронный звук у готового клипа ── */
let audioEl = null;
let headRaf = 0;
function audio() {
    if (!audioEl) {
        audioEl = document.createElement('audio');
        audioEl.preload = 'auto';
        audioEl.hidden = true;
        document.body.append(audioEl);
        audioEl.addEventListener('ended', listenStop);
    }
    if (state.songUrl && audioEl.src !== state.songUrl) audioEl.src = state.songUrl;
    return audioEl;
}
function listenStart() {
    if (!state.songUrl) return;
    const a = audio();
    const v = $('cgVideo');
    if (v && !v.paused) v.pause();
    let from = state.win.from;
    if (state.selected && state.selected.kind === 'scene') from = sceneAbsStart(state.selected.index);
    else if (state.selected && state.selected.kind === 'part' && state.parts) {
        const p = state.parts.parts.find((q) => q.label === state.selected.label);
        if (p) from = p.t0;
    }
    a.dataset.mode = 'listen';
    a.currentTime = from;
    a.play().catch(() => { /* жест есть — отказ только у сломанного устройства вывода */ });
    setListenUi(true);
    const tick = () => {
        if (!audioEl || audioEl.paused || audioEl.dataset.mode !== 'listen') return;
        playhead(audioEl.currentTime);
        sungLine(lineAt(audioEl.currentTime));
        headRaf = requestAnimationFrame(tick);
    };
    cancelAnimationFrame(headRaf);
    headRaf = requestAnimationFrame(tick);
    funnel('listen', { from: Math.round(from) });
}
function listenStop() {
    if (audioEl && audioEl.dataset.mode === 'listen') { try { audioEl.pause(); } catch (_) { /* — */ } }
    cancelAnimationFrame(headRaf);
    playhead(null);
    sungLine('');
    setListenUi(false);
}
/** Строка, которую сейчас поют, — под шкалой, пока играет «Слушать»: так
    видно, легли ли слова на голос, ещё до клипа. Пишется, только когда другая. */
function sungLine(text) {
    const el = $('cgTlLyr');
    if (!el) return;
    textWrite(el, text || '');
    el.hidden = !text;
}
/* Текст из цикла кадров — общим примитивом (пишет, только когда другой), с
   местным запасом: страница со старым ядром из кэша получит этот файл новым. */
function textWrite(e, t) { if (window.__setText) return window.__setText(e, t); e.textContent = t; }
function setListenUi(on) {
    const b = $('cgListen'), l = $('cgListenLabel'), ic = $('cgListenIcon');
    if (b) b.setAttribute('aria-pressed', on ? 'true' : 'false');
    if (l) l.textContent = on ? (I.tl_stop || '') : (I.tl_listen || '');
    if (ic) ic.innerHTML = on ? '<rect x="6" y="5" width="4" height="14" rx="1"/><rect x="14" y="5" width="4" height="14" rx="1"/>' : '<path d="M8 5.5v13l11-6.5z"/>';
}

/** Песня рядом с результатом — синхронно с видео, со сдвигом окна. */
let synced = false;
function songAudio(on) {
    const v = $('cgVideo');
    if (!on || !state.songUrl || !state.resultHasSong) {
        if (audioEl && audioEl.dataset.mode === 'result') { try { audioEl.pause(); } catch (_) { /* — */ } }
        return;
    }
    const a = audio();
    a.dataset.mode = 'result';
    if (synced || !v) return;
    synced = true;
    const off = () => state.resultFrom;
    // Музыка в самом файле (serverAudio) — звучит ролик, вторая копия молчит.
    const own = () => a.dataset.mode === 'result' && state.resultHasSong && !state.serverAudio;
    v.addEventListener('play', () => { if (own()) { a.currentTime = off() + v.currentTime; a.play().catch(() => {}); } });
    v.addEventListener('pause', () => { if (a.dataset.mode === 'result') a.pause(); });
    v.addEventListener('seeking', () => { if (own()) a.currentTime = off() + v.currentTime; });
    v.addEventListener('timeupdate', () => {
        if (own() && !v.paused && Math.abs(a.currentTime - (off() + v.currentTime)) > 0.25) a.currentTime = off() + v.currentTime;
        playhead(state.song && state.shown === 'result' && state.resultHasSong ? off() + v.currentTime : null);
    });
}

/* ══════════════════════════════════════════════════════════ ОБЛОЖКА ══ */

async function decodeImage(file) {
    try { return await createImageBitmap(file); } catch (_) { /* ниже — через <img> (HEIC в Safari) */ }
    return new Promise((res) => {
        const url = URL.createObjectURL(file);
        const img = new Image();
        img.onload = () => { res(img); URL.revokeObjectURL(url); };
        img.onerror = () => { res(null); URL.revokeObjectURL(url); };
        img.src = url;
    });
}
async function shrinkImage(file, maxSide) {
    const src = await decodeImage(file);
    if (!src) return null;
    const sw = src.width || src.naturalWidth, sh = src.height || src.naturalHeight;
    if (!sw || !sh) return null;
    const k = Math.min(1, maxSide / Math.max(sw, sh));
    const c = document.createElement('canvas');
    c.width = Math.max(1, Math.round(sw * k));
    c.height = Math.max(1, Math.round(sh * k));
    const g = c.getContext('2d');
    if (!g) return null;
    g.drawImage(src, 0, 0, c.width, c.height);
    try { src.close && src.close(); } catch (_) { /* — */ }
    if (window.__canvasBlob) { try { return await window.__canvasBlob(c, 'image/jpeg', 0.88); } catch (_) { return null; } }
    return new Promise((res) => c.toBlob((b) => res(b), 'image/jpeg', 0.88));
}
let coverUrl = null;
async function onImage(file) {
    if (!file) return;
    const blob = await shrinkImage(file, 768);
    if (!blob) {
        state.image = null;
        msg(I.image_failed || I.error_generic, 'warn');
        critical('clip_cover_unreadable', { type: file.type, size: file.size });
        if (draft) draft.coverFailed();
        return;
    }
    state.image = blob;
    try { if (coverUrl) URL.revokeObjectURL(coverUrl); } catch (_) { /* — */ }
    coverUrl = URL.createObjectURL(blob);
    const zone = $('cgImage');
    if (zone) zone.style.setProperty('--cg-cover', 'url("' + coverUrl + '")');
    $('cgCoverLine') && ($('cgCoverLine').hidden = false);
    funnel('cover_loaded', { kb: Math.round(blob.size / 1024) });
    if (draft) draft.coverReady();
}
function dropImage() {
    state.image = null;
    $('cgCoverLine') && ($('cgCoverLine').hidden = true);
    const zone = $('cgImage');
    if (zone) zone.style.removeProperty('--cg-cover');
}

/* ══════════════════════════════════════════════════════════ СЦЕНА ═════ */

function screenAspect(ar, arn, key) {
    const sc = $('cgScreen');
    if (!sc) return;
    sc.style.setProperty('--cg-ar', ar || state.ar);
    sc.style.setProperty('--cg-arn', arn || state.arn);
    sc.dataset.aspect = key || state.aspect;
}
function stageHead(title, badge, done) {
    const t = $('cgStageTitle'), b = $('cgStageBadge');
    if (t) t.textContent = title || '';
    if (b) { b.textContent = badge || ''; b.hidden = !badge; b.classList.toggle('done', !!done); }
}
/** Что сейчас в экране: gallery | video | progress — от этого его форма на телефоне. */
function screenState(st) {
    const sc = $('cgScreen');
    if (sc) sc.dataset.state = st;
    const sub = $('cgStageSub');
    if (sub) sub.hidden = st !== 'gallery';
}

/** Кадр сцены из раскадровки — крупно, пока экран не занят клипом или пробой. */
function showStillOnStage(src, sc) {
    if (!src || (state.shown !== 'gallery' && state.shown !== 'still' && state.shown !== '')) return;
    const img = $('cgStill');
    if (!img) return;
    stageSwap(() => {
        $('cgGallery') && ($('cgGallery').hidden = true);
        screenAspect();
        screenState('video');
        img.src = src;
        img.hidden = false;
        $('cgBack') && ($('cgBack').hidden = !document.querySelector('.cg-ex'));
    });
    stageHead(tr('board_still_title', { n: sc.i + 1, span: fmtSceneT(sc.from) + '–' + fmtSceneT(sc.to) }), I.board_still_badge || '');
    state.shown = 'still';
}

function showGallery() {
    const v = $('cgVideo');
    $('cgStill') && ($('cgStill').hidden = true);
    songAudio(false);
    setOverlay(false);
    $('cgRedo') && ($('cgRedo').hidden = true); paintSinger(false);
    $('cgSongHint') && ($('cgSongHint').hidden = true);
    stageSwap(() => {
        if (v) { try { v.pause(); } catch (_) { /* — */ } v.removeAttribute('src'); v.load(); v.hidden = true; }
        $('cgPlay') && ($('cgPlay').hidden = true);
        $('cgGallery') && ($('cgGallery').hidden = false);
        $('cgResultActions') && ($('cgResultActions').hidden = true);
        $('cgBack') && ($('cgBack').hidden = true);
        hideProgress();
        screenAspect();
        screenState('gallery');
        stageHead(I.gallery_title || '', '');
    });
    document.querySelectorAll('.cg-ex').forEach((c) => c.setAttribute('aria-pressed', 'false'));
    state.shown = 'gallery';
    libMark(null);
    paintBoard();
    paintDraft();
}

function showVideo(url, kind, opts) {
    const v = $('cgVideo');
    if (!v) return;
    state.shown = kind;
    $('cgStill') && ($('cgStill').hidden = true);
    paintBoard();
    paintDraft();
    if (kind !== 'result') {
        setOverlay(false);
        $('cgRedo') && ($('cgRedo').hidden = true); paintSinger(false);
        $('cgSongHint') && ($('cgSongHint').hidden = true);
    }
    stageSwap(() => {
        hideProgress();
        $('cgGallery') && ($('cgGallery').hidden = true);
        if (kind === 'example' && opts && opts.ar) screenAspect(opts.ar, opts.arn, opts.aspect);
        else if (opts && opts.ar) screenAspect(opts.ar, opts.arn, opts.aspect);
        else screenAspect();
        screenState('video');
        v.muted = true;
        v.src = url;
        v.hidden = false;
        $('cgResultActions') && ($('cgResultActions').hidden = kind !== 'result');
        $('cgBack') && ($('cgBack').hidden = !document.querySelector('.cg-ex'));
    });
    // Клип на песню не запускаем беззвучно: человек должен услышать его с
    // музыкой — кнопка «▶ Смотреть с музыкой» стоит поверх кадра.
    if (kind === 'result' && (state.resultHasSong || state.serverAudio)) return;
    v.play().catch(() => { /* кнопка ▶ на месте */ });
}

function bindPlayOverlay() {
    const v = $('cgVideo'), p = $('cgPlay'), lab = $('cgPlayLabel');
    if (!v || !p) return;
    const sync = () => {
        p.hidden = v.hidden || !v.currentSrc || !v.paused;
        if (lab) lab.textContent = (state.shown === 'result' && (state.serverAudio || (state.resultHasSong && state.songUrl))) ? (I.play_music || '') : '';
    };
    ['play', 'pause', 'ended', 'loadedmetadata', 'emptied'].forEach((ev) => v.addEventListener(ev, sync));
    // Звук результата: свой у файла (serverAudio) — включить его; иначе — песня страницы рядом.
    const withSound = () => {
        if (state.shown !== 'result') return;
        if (state.serverAudio) v.muted = false;
        else if (state.resultHasSong) songAudio(true);
    };
    p.addEventListener('click', () => {
        listenStop();
        withSound();
        v.play().catch(() => {});
        funnel('play_click', { what: state.shown });
    });
    v.addEventListener('click', () => { if (v.paused) { listenStop(); withSound(); v.play().catch(() => {}); } else v.pause(); });
    sync();
}

function showProgress(title, text) {
    $('cgGallery') && ($('cgGallery').hidden = true);
    screenState('progress');
    $('cgProgress') && ($('cgProgress').hidden = false);
    $('cgProgressTitle') && ($('cgProgressTitle').textContent = title || '');
    $('cgProgressText') && ($('cgProgressText').textContent = text || '');
}
function hideProgress() { $('cgProgress') && ($('cgProgress').hidden = true); }

/** Полоса от ЧАСОВ: 97 % — «ещё работаем», 100 % рисует только результат. */
/**
 * Полоса и слова — от ФАЗЫ, которую знает сервер (ClipQueue): «в очереди за
 * N клипами», «запускаем генератор», «рисуем». До 26.10 полоса шла от нажатия
 * по средней скорости и за чужим клипом в очереди «висела» на 97 %. Между
 * опросами «осталось» тикает вниз; полоса не идёт назад (максимум из
 * показанного); 100 % рисует только результат.
 */
function tickProgress(kindTitle) {
    const fill = $('cgBarFill'), bar = $('cgBar');
    if (!fill || !state.startedAt) return;
    // Стенные часы, а не активное время вкладки: прогон идёт на НАШЕМ сервере
    // и не замирает, когда вкладка спит.
    const gone = Math.max(0, (Date.now() - state.startedAt) / 1000);
    const q = state.queue;
    let left, title = kindTitle || I.generating || '';
    if (q && typeof q.left_s === 'number') {
        left = Math.max(0, q.left_s - (Date.now() - state.queueAt) / 1000);
        if (q.phase === 'queue') title = tr('phase_queue', { n: q.ahead });
        else if (q.phase === 'start') title = I.phase_start || title;
        else if (state.waitKind === 'redo') title = left > 5 ? (I.phase_redo || title) : (I.phase_splice || title);
        else if (state.waitKind === 'singer') title = left > 30 ? (I.phase_singer || title) : (I.phase_singer_cut || title);
        else title = I.phase_render || title;
    } else {
        left = Math.max(0, state.etaS - gone);
    }
    const pct = Math.max(state.barMax, Math.min(97, (gone / Math.max(1, gone + left)) * 100));
    state.barMax = pct;
    fill.style.width = pct.toFixed(1) + '%';
    if (bar) bar.setAttribute('aria-valuenow', String(Math.round(pct)));
    const text = left > 5 ? tr('eta_hint', { n: fmtMin(left) }) : (I.still_working || '');
    $('cgProgressTitle') && ($('cgProgressTitle').textContent = title);
    $('cgProgressText') && ($('cgProgressText').textContent = text);
    status(title + ' · ' + text);
}

/* ══════════════════════════════════════════════════════════ ПРИМЕРЫ ═══ */

function openExample(card) {
    if (!card) return;
    document.querySelectorAll('.cg-ex').forEach((c) => c.setAttribute('aria-pressed', c === card ? 'true' : 'false'));
    state.exampleKey = card.dataset.key || null;
    if (card.dataset.look) pickLook(card.dataset.look, true);
    if (card.dataset.style) pickStyle(card.dataset.style, true);
    const ab = card.dataset.aspect && document.querySelector('#cgAspect [data-aspect="' + CSS.escape(card.dataset.aspect) + '"]');
    if (ab) pickAspect(ab, true);

    const ta = $('cgPrompt');
    const ex = card.dataset.prompt || '';
    const line = $('cgExLine'), lineText = $('cgExLineText');
    const own = ta ? ta.value.trim() : '';
    if (ta && ex && (own === '' || own === state.exPromptInserted)) {
        ta.value = ex;
        state.exPromptInserted = ex;
        ta.dispatchEvent(new Event('input', { bubbles: true }));
        if (line) line.hidden = true;
        funnel('example_prompt_used', { key: state.exampleKey, how: 'auto' });
    } else if (line && lineText && ex) {
        lineText.textContent = (I.example_prompt_label || '') + ' «' + ex + '»';
        line.hidden = false;
    }
    listenStop();
    songAudio(false);
    stageHead(I.example_title || '', (I.example_badge || '') + ' · ' + (I['look_' + (card.dataset.look || 'plain')] || ''));
    showVideo(card.dataset.src, 'example', { ar: card.dataset.ar, arn: card.dataset.arn, aspect: card.dataset.aspect });
    msg(I.example_applied || '', '');
    funnel('example_open', { key: state.exampleKey, look: card.dataset.look, aspect: card.dataset.aspect });
}

function bindExamples() {
    const grid = $('cgGallery');
    if (!grid) return;
    grid.addEventListener('click', (e) => {
        const card = e.target.closest('.cg-ex');
        if (card) openExample(card);
    });
    // Под указателем мыши плитка ОЖИВАЕТ — играет свой ролик без звука. Только
    // мышь: на касании «наведения» нет, а нажатие открывает пример в экране.
    if (window.matchMedia && window.matchMedia('(hover:hover) and (pointer:fine)').matches) {
        grid.addEventListener('pointerover', (e) => {
            const card = e.target.closest('.cg-ex');
            if (!card || card.querySelector('video') || e.pointerType !== 'mouse') return;
            const v = document.createElement('video');
            v.muted = true; v.loop = true; v.playsInline = true; v.preload = 'auto';
            v.setAttribute('aria-hidden', 'true');
            v.src = card.dataset.src;
            card.insertBefore(v, card.querySelector('.cg-ex-fmt'));
            v.play().catch(() => v.remove());
        });
        grid.addEventListener('pointerout', (e) => {
            const card = e.target.closest('.cg-ex');
            if (!card || (e.relatedTarget && card.contains(e.relatedTarget))) return;
            const v = card.querySelector('video');
            if (v) { try { v.pause(); } catch (_) { /* — */ } v.removeAttribute('src'); v.load(); v.remove(); }
        });
    }
    const use = $('cgExUse');
    if (use) use.addEventListener('click', () => {
        const card = document.querySelector('.cg-ex[aria-pressed=true]');
        const ta = $('cgPrompt');
        if (!card || !ta) return;
        ta.value = card.dataset.prompt || '';
        state.exPromptInserted = ta.value;
        ta.dispatchEvent(new Event('input', { bubbles: true }));
        $('cgExLine') && ($('cgExLine').hidden = true);
        ta.focus();
        funnel('example_prompt_used', { key: card.dataset.key, how: 'button' });
    });
    const back = $('cgBack');
    if (back) back.addEventListener('click', () => { showGallery(); msg(''); funnel('gallery_back', {}); });
}

/* ══════════════════════════════════════════════════════════ ВЫБОРЫ ════ */

function pickLook(k, silent) {
    state.look = k;
    radio($('cgLook'), 'look', k);
    const n = $('cgLookName');
    if (n) n.textContent = I['look_' + k] || k;
    save('look', k);
    if (!silent) funnel('look_pick', { look: k });
}
function pickStyle(s, silent) {
    state.style = s;
    radio($('cgStyle'), 'style', s);
    save('style', s);
    refreshPills();
    if (!silent) funnel('camera_pick', { style: s });
}
function pickAspect(b, silent) {
    state.aspect = b.dataset.aspect;
    state.ratio = b.dataset.ratio || state.ratio;
    state.ar = b.dataset.ar || state.ar;
    state.arn = b.dataset.arn || state.arn;
    radio($('cgAspect'), 'aspect', state.aspect);
    const app = $('cgApp');
    if (app) { app.style.setProperty('--cg-ar', state.ar); app.style.setProperty('--cg-arn', state.arn); app.dataset.aspect = state.aspect; }
    if (state.shown === 'gallery' || state.shown === '') screenAspect();
    if (!silent) { state.canvas = false; save('aspect', state.aspect); funnel('aspect_pick', { aspect: state.aspect }); }
    refreshPills();
}

function applyCanvas() {
    const vb = document.querySelector('#cgAspect [data-aspect="vertical"]');
    if (vb) pickAspect(vb, true);
    state.canvas = true;
    if (state.song) {
        const w = windowsFor();
        setWindow(w.canvas.from, w.canvas.to, 'canvas', true);
    } else {
        state.seconds = 8;
        radio($('cgLength'), 'seconds', 8);
        replan();
    }
    msg(I.canvas_applied || '', '');
    funnel('canvas_preset', { song: state.song ? 1 : 0 });
}

function bindChoices() {
    const looks = $('cgLook');
    if (looks) looks.addEventListener('click', (e) => {
        const b = e.target.closest('[data-look]');
        if (b) pickLook(b.dataset.look);
    });
    const styleBox = $('cgStyle');
    if (styleBox) styleBox.addEventListener('click', (e) => {
        const b = e.target.closest('[data-style]');
        if (b) pickStyle(b.dataset.style);
    });
    const aspect = $('cgAspect');
    if (aspect) aspect.addEventListener('click', (e) => {
        const b = e.target.closest('[data-aspect]');
        if (b) pickAspect(b);
    });
    $('cgCanvasPreset') && $('cgCanvasPreset').addEventListener('click', () => { applyCanvas(); closePop('cgPopFmt'); });

    const len = $('cgLength');
    if (len) len.addEventListener('click', (e) => {
        const b = e.target.closest('[data-seconds]');
        if (!b) return;
        state.seconds = +b.dataset.seconds;
        state.canvas = false;
        radio(len, 'seconds', state.seconds);
        replan();
        funnel('length_pick', { s: state.seconds });
    });
    const win = $('cgWindow');
    if (win) win.addEventListener('click', (e) => {
        const b = e.target.closest('[data-win]');
        if (!b || !state.song) return;
        const k = b.dataset.win;
        const w = windowsFor();
        state.canvas = (k === 'canvas');
        if (k === 'canvas') { applyCanvas(); return; }
        if (k === 'custom') {
            setWindow(state.win.from, state.win.to, 'custom', false);
            msg(I.win_custom_hint ? '' : '', '');
            const h = $('cgTlH0');
            if (h) h.focus({ preventScroll: true });
        } else if (w[k]) {
            setWindow(w[k].from, w[k].to, k, true);
        }
        funnel('window_pick', { kind: k, s: Math.round(state.seconds) });
    });

    const cad = $('cgCadence');
    if (cad) cad.addEventListener('click', (e) => {
        const b = e.target.closest('[data-bars],[data-cadence]');
        if (!b) return;
        if (b.dataset.bars) {
            state.bars = +b.dataset.bars;
            radio(cad, 'bars', state.bars);
            funnel('cadence_pick', { bars: state.bars });
        } else {
            state.cadenceS = +b.dataset.cadence;
            radio(cad, 'cadence', state.cadenceS);
            funnel('cadence_pick', { s: state.cadenceS });
        }
        replan();
    });
    const pf = $('cgPeakFaster');
    if (pf) pf.addEventListener('change', () => { state.peakFaster = pf.checked; replan(); funnel('peak_faster', { on: pf.checked ? 1 : 0 }); });

    const motion = $('cgMotion');
    if (motion) motion.addEventListener('click', (e) => {
        const b = e.target.closest('[data-react]');
        if (!b) return;
        state.react = +b.dataset.react;
        radio(motion, 'react', b.dataset.react);
        save('react', state.react);
        refreshPills();
        funnel('motion_pick', { react: state.react, song: state.song ? 1 : 0 });
    });

    const qualPick = (box, attr, apply) => {
        if (!box) return;
        box.addEventListener('click', (e) => {
            const b = e.target.closest('[data-' + attr + ']');
            if (!b) return;
            if (b.dataset.pro === '1' && !state.pro) {
                $('cgQualPerk') && ($('cgQualPerk').hidden = false);
                funnel('perk_wall', { perk: 'clip_' + attr });
                return;
            }
            apply(+b.dataset[attr]);
            radio(box, attr, b.dataset[attr]);
            refreshPills();
        });
    };
    qualPick($('cgRes'), 'res', (v) => { state.res = v; save('res', v); funnel('res_pick', { res: v }); });
    qualPick($('cgFps'), 'fps', (v) => { state.fps = v; save('fps', v); funnel('fps_pick', { fps: v }); });
}

/* ══════════════════════════════════════════════════════ ИДЕИ ═══════ */
function nextIdea() {
    const ideas = Array.isArray(I.ideas) ? I.ideas : [];
    if (!ideas.length) return;
    state.ideaAt = (state.ideaAt + 1 + Math.floor(Math.random() * Math.max(1, ideas.length - 1))) % ideas.length;
    const ta = $('cgPrompt');
    if (!ta) return;
    ta.value = ideas[state.ideaAt];
    ta.dispatchEvent(new Event('input', { bubbles: true }));
    ta.focus();
    funnel('idea_used', { i: state.ideaAt });
}

/* ══════════════════════════════════════════════════════ ЗАПРОСЫ ═════ */

async function post(url, body) {
    const isForm = (typeof FormData !== 'undefined') && body instanceof FormData;
    const headers = { 'X-CSRF-TOKEN': csrf(), 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/json' };
    if (!isForm) headers['Content-Type'] = 'application/json';
    const res = await fetch(url, { method: 'POST', headers, body: isForm ? body : JSON.stringify(body), redirect: 'error', credentials: 'same-origin' });
    let data = null;
    try { data = await res.json(); } catch (_) { /* разберём по статусу */ }
    return { res, data };
}

function planForServer() {
    const texts = state.cuts.map((_, i) => promptForScene(i));
    const seeds = state.cuts.map((_, i) => sceneSeedAt(i));
    const anyText = texts.some((x) => x);
    const anySeed = seeds.some((x) => x !== null);
    if (!state.song && !anyText && !anySeed) return null;
    const plan = cutsToPlan(state.cuts, state.seconds, texts);
    // Свой сид сцены (перерисованный кадр раскадровки) — клип начнёт её с того же кадра.
    if (anySeed) plan.forEach((p, i) => { if (seeds[i] !== null) p.seed = seeds[i]; });
    return plan;
}

/**
 * Тело запроса клипа — ОДНО на «Собрать клип» и раскадровку. `extra.seed` —
 * сид раскадровки (у «Собрать клип» — её сид, если кадры ещё верны), `extra.only`
 * — номера сцен (с 1) для «перерисовать кадр».
 */
function payload(prompt, extra) {
    extra = extra || {};
    const fields = {
        tool: SLUG,
        // Основное описание может быть пустым, когда описаны части песни:
        // тогда общим становится описание первой части (needPrompt).
        prompt: prompt || ($('cgPrompt') || {}).value || '',
        style: state.style, look: state.look, aspect: state.aspect,
        seconds: +state.seconds.toFixed(2),
        cadence: +state.cadenceS.toFixed(2),
    };
    // Сид: раскадровки (клип начнётся с показанных кадров) — иначе «Тот же образ».
    const sbs = ('seed' in extra) ? extra.seed : boardSeed();
    if (sbs !== null && sbs !== undefined) fields.seed = sbs;
    else if (state.keepSeed && state.lastSeed !== null) fields.seed = state.lastSeed;
    if (extra.only) fields.only = extra.only;
    // Под какую песню клип (только имя, длина, начало окна — песня не едет):
    // открыв клип позже, страница узнает её и отдаст клип с музыкой.
    const songMeta = state.song ? { name: state.song.name || '', dur: +state.song.duration.toFixed(2), from: +state.win.from.toFixed(3) } : null;
    if (CG.hd && state.res >= 1080) fields.res = 1080;
    if (CG.smooth && state.fps >= 24) fields.fps_out = 24;
    const shots = planForServer();
    let react = null;
    if (CG.motion && state.react > 0 && state.song && state.buffer) {
        const rc = reactCurve(state.buffer, state.song.beats, state.win.from, state.seconds, GEN_FPS);
        react = { react: state.react, energy: rc.energy, hits: rc.hits };
    }
    if (!state.image) {
        if (shots) fields.shots = shots;
        if (react) Object.assign(fields, react);
        if (songMeta) fields.song = songMeta;
        return fields;
    }
    const fd = new FormData();
    Object.keys(fields).forEach((k) => { if (k !== 'only') fd.append(k, String(fields[k])); });
    if (extra.only) extra.only.forEach((k) => fd.append('only[]', String(k)));
    if (shots) fd.append('shots', JSON.stringify(shots));
    if (react) {
        fd.append('react', String(react.react));
        fd.append('energy', JSON.stringify(react.energy));
        fd.append('hits', JSON.stringify(react.hits));
    }
    if (songMeta) fd.append('song', JSON.stringify(songMeta));
    fd.append('image', state.image, 'cover.jpg');
    return fd;
}

/* ── отказы ── */
function openWall(short) {
    const a = $('cgTopup');
    if (!a) { msg(I.insufficient || '', 'warn'); return; }
    if (short > 0) a.setAttribute('data-tmb-short', String(short));
    a.hidden = false;
    funnel('wall_open', { short: short || 0 });
    a.click();
}
function handleRefusal(st, data, what) {
    const err = (data && data.error) || '';
    funnel((what || 'generate') + '_refused', { status: st, err });
    status('');
    if (st === 401 || err === 'auth') { state.authed = false; refreshWallet(); msg(I.login_required, 'warn'); return; }
    if (st === 402 || err === 'insufficient_tokens') {
        if (data && typeof data.balance === 'number') setBalance(data.balance);
        const need = (data && data.need) || tokensFor(state.seconds);
        const short = Math.max(0, need - (typeof state.balance === 'number' ? state.balance : 0));
        msg((I.insufficient || '') + (short ? ' ' + tr('short_line', { n: fmtNum(short) }) : ''), 'warn');
        openWall(short);
        return;
    }
    if (err === 'singer_unavailable') { state.singWhy = (data && data.why) || null; refreshResultSong(); return; }
    if (err === 'redo_unavailable') { state.redoWhy = (data && data.why) || null; msg(redoWhyText(state.redoWhy), 'warn'); refreshResultSong(); return; }
    if (err === 'premium_only') { msg(I.premium_only || '', 'warn'); $('cgQualPerk') && ($('cgQualPerk').hidden = false); return; }
    if (st === 429 && err === 'preview_limit') { msg(I.preview_limit, 'warn'); return; }
    if (st === 503 || err === 'disabled') { msg(I.coming_soon, ''); return; }
    msg((data && data.msg) || I.error_generic, 'bad');
    critical('clip_' + (what || 'generate') + '_refused', { status: st, err });
}

function needPrompt() {
    const prompt = (($('cgPrompt') || {}).value || '').trim();
    const anyPart = Object.values(state.partText).some((x) => x && x.trim());
    if (prompt.length >= 3) return prompt;
    if (anyPart || state.sceneText.length) return prompt || (Object.values(state.partText).find((x) => x && x.trim()) || state.sceneText[0].text);
    msg(I.need_prompt, 'warn');
    $('cgPrompt') && $('cgPrompt').focus();
    funnel('need_prompt', {});
    return null;
}

/* ══════════════════════════════════════════════════════ ПРОГОН ══════ */

async function run() {
    if (state.busy) return;
    const prompt = needPrompt();
    if (!prompt) return;
    if (!state.authed) { handleRefusal(401, { error: 'auth' }, 'generate'); return; }
    listenStop();
    setBusy(true);
    msg('');
    stageT('generate_start');
    funnel('generate_start', {
        seconds: Math.round(state.seconds), tokens: tokensFor(state.seconds), song: state.song ? 1 : 0,
        cover: state.image ? 1 : 0, look: state.look, style: state.style, aspect: state.aspect,
        shots: state.cuts.length, seed: state.keepSeed ? 1 : 0, win: state.song ? state.win.kind : '',
        parts: state.parts ? state.parts.parts.length : 0, react: state.react, res: state.res, fps: state.fps,
        own: state.sceneText.length + Object.keys(state.partText).filter((k) => state.partText[k]).length,
    });
    const body = payload(prompt);
    const { res, data } = await post(U.generate, body);
    if (!res.ok || !data || !data.ok) {
        setBusy(false);
        hideProgress();
        handleRefusal(res.status, data, 'generate');
        return;
    }
    state.id = data.id;
    state.sessionIds.add(data.id);
    state.startedAt = Date.now();
    state.resultFrom = state.song ? state.win.from : 0;
    state.resultSeconds = state.seconds;
    state.genSong = !!state.song;
    if (typeof data.balance === 'number') setBalance(data.balance);
    try { window.__pendingJobAttached = { tool: SLUG, id: String(data.id) }; } catch (_) { /* — */ }
    // Песня — на сервер, пока клип рисуется: выданный файл понесёт её сам.
    if (state.song && !state.canvas) sendSong(data.id);
    libPrepend({ id: data.id, status: 'queued', prompt, created_at: new Date().toISOString() });
    state.waitKind = 'clip';
    state.queue = null;
    lyrAttachTo(data.id);
    startWaiting(I.generating || '');
    msg('');
    poll();
}

/* Подсмотр «сейчас рисуется» (29.10.2026): последний кадр воркера со статусом
   клипа — человек видит, туда ли идёт клип, с первых минут, а не через 15. */
let peekSeenFor = null;
function showPeek(pk) {
    const box = $('cgPeekBox'), img = $('cgPeek');
    if (!box || !img || !pk || !pk.src) return;
    if (img.getAttribute('src') !== pk.src) img.src = pk.src;
    const cap = $('cgPeekCap');
    if (cap) cap.textContent = pk.scene && pk.scenes ? tr('peek_cap', { n: pk.scene, total: pk.scenes }) : '';
    box.hidden = false;
    if (peekSeenFor !== state.id) {
        peekSeenFor = state.id;
        funnel('peek_seen', { kind: state.waitKind || 'clip', scenes: pk.scenes || 0 });
    }
}
function hidePeek() {
    const box = $('cgPeekBox'), img = $('cgPeek');
    if (box) box.hidden = true;
    if (img) img.removeAttribute('src');
}

function startWaiting(title, isPreview) {
    hidePeek();
    state.barMax = 0;
    setOverlay(false);
    const note = document.querySelector('.cg-progress-n');
    if (note) note.hidden = !!isPreview;
    songAudio(false);
    stageSwap(() => {
        const v = $('cgVideo');
        if (v) { try { v.pause(); } catch (_) { /* — */ } v.hidden = true; }
        $('cgPlay') && ($('cgPlay').hidden = true);
        $('cgResultActions') && ($('cgResultActions').hidden = true);
        $('cgBack') && ($('cgBack').hidden = true);
        screenAspect();
        showProgress(title, '');
        stageHead(I.result_title || '', '');
    });
    state.shown = 'progress';
    paintBoard();
    paintDraft();
    tickProgress(title);
    // На телефоне сцена под рейкой: человек нажал внизу рейки — показать ход
    // работы, только если экран вне окна, и только «до ближайшего края».
    const sc = $('cgScreen');
    if (sc) {
        const r = sc.getBoundingClientRect();
        if (r.bottom < 0 || r.top > innerHeight) sc.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
    }
}

function poll() {
    clearInterval(state.timer);
    state.timer = setInterval(async () => {
        tickProgress(I.generating || '');
        let data = null;
        try {
            const r = await fetch(U.status + '/' + state.id, { headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, credentials: 'same-origin' });
            data = await r.json();
        } catch (_) { return; }
        if (!data) return;
        if (data.queue) { state.queue = data.queue; state.queueAt = Date.now(); }
        if (data.peek && data.status !== 'done' && data.status !== 'failed') showPeek(data.peek);
        if (data.status === 'done') {
            clearInterval(state.timer);
            hidePeek();
            setBusy(false);
            status('');
            deliver(data, state.waitKind === 'redo' || state.waitKind === 'singer' ? state.waitKind : true);
            libUpdate({ id: data.id, status: 'done', variants: data.variants });
            return;
        }
        if (data.status === 'failed') {
            clearInterval(state.timer);
            setBusy(false);
            status('');
            hidePeek();
            hideProgress();
            showGallery();
            msg(data.refunded ? I.error_generic : (data.error || I.error_generic), 'bad');
            critical('clip_failed', { error: data.error, refunded: !!data.refunded });
            funnel('clip_failed', { refunded: data.refunded ? 1 : 0 });
            libUpdate({ id: data.id, status: 'failed', refunded: !!data.refunded });
        }
    }, 4000);
}

/**
 * Готовый клип в сцене. `fresh` — пришёл из ЭТОГО прогона (песня та же, окно
 * то же), иначе — открыт из «Моих клипов» и звук к нему не приклеиваем: чья
 * песня под ним, страница не знает.
 */
function deliver(data, fresh) {
    const v = (data.variants || [])[0];
    if (!v || !v.url) { hideProgress(); msg(I.error_generic, 'bad'); return; }
    const meta = data.meta || {};
    const clip = data.clip || {};
    const wasRedo = fresh === 'redo';
    const wasSinger = fresh === 'singer';
    state.lastUrl = v.url;
    state.lastDl = v.dl_url || null;
    state.lastId = data.id;
    state.outBlob = null;
    // Музыка уже в файле (сведена на сервере) — играем и отдаём его как есть.
    state.serverAudio = !!v.audio;
    if (meta.seed !== undefined && meta.seed !== null) state.lastSeed = meta.seed;
    state.resultSong = clip.song || null;
    state.resultScenes = Array.isArray(clip.scenes) ? clip.scenes : [];
    state.resultShotsSrc = Array.isArray(data.shots_src) ? data.shots_src : [];
    state.resultPrompt = data.prompt || '';
    state.resultSeconds = +clip.seconds || state.resultSeconds;
    state.canRedo = !!(REDO.enabled && data.can_redo);
    state.redoWhy = data.redo_why || null;
    // Поющий персонаж: причина «нельзя» — от сервера (ClipSinger::refusal);
    // старый ответ без поля — кнопки нет.
    state.singWhy = SINGER.enabled ? (data.sing_why === undefined ? 'disabled' : data.sing_why) : 'disabled';
    state.proUrl = data.pro_url || '';
    state.resultAspect = clip.aspect || '';
    // С музыкой — если песня та же: только что собран под неё, пересъёмка
    // клипа под неё, или выбрана снова (сверка по длине, clip.song).
    state.resultHasSong = !!((fresh === true && state.genSong && state.song) || songMatches(state.resultSong));
    if ((state.resultHasSong || state.serverAudio) && state.resultSong && (fresh !== true)) state.resultFrom = +state.resultSong.from || 0;
    // Немой клип своей песни, а песня у страницы есть (вернулся, выбрал снова,
    // черновик вернул её) — отдать серверу: следующая выдача будет с музыкой.
    if (!state.serverAudio && state.resultHasSong && state.resultSong && !state.canvas) sendSong(data.id);
    fresh = fresh === true || wasRedo || wasSinger;
    const ks = $('cgKeepSeed');
    if (ks) { ks.hidden = state.lastSeed === null; ks.setAttribute('aria-pressed', state.keepSeed ? 'true' : 'false'); }
    const share = $('cgShare');
    if (share) {
        let can = false;
        try { can = !!(navigator.canShare && navigator.canShare({ files: [new File([new Uint8Array(1)], 'c.mp4', { type: 'video/mp4' })] })); } catch (_) { can = false; }
        share.hidden = !can;
    }
    paintMore();
    stageHead(I.result_title || '', I.result_badge || '', true);
    const ab = meta.aspect && document.querySelector('#cgAspect [data-aspect="' + CSS.escape(meta.aspect) + '"]');
    showVideo(v.url, 'result', ab ? { ar: ab.dataset.ar, arn: ab.dataset.arn, aspect: meta.aspect } : null);
    const shots = meta.shots || 0;
    msg(wasSinger && clip.singer ? tr('singer_done', { n: (clip.singer.scenes || []).length })
        : wasRedo && clip.redo && clip.redo.scenes && clip.redo.scenes.length > 1
            ? tr('redo_done_many', { list: clip.redo.scenes.map((s) => s + 1).join(', ') })
        : wasRedo && clip.redo ? tr('redo_done', { n: clip.redo.scene + 1 })
        : (shots ? tr('shots_made', { n: shots }) : ''), wasRedo || wasSinger ? 'good' : '');
    libMark(data.id);
    // Слова клипа вернулись вместе с ним; у только что собранного — уже на месте.
    if (data.lyrics && data.lyrics.lines && data.lyrics.lines.length) lyrLoadSaved(data.lyrics, state.resultSong);
    else if (lyrState().timed) lyrLibs();
    refreshResultSong();
    if (fresh) {
        const waited = state.startedAt ? Math.round((Date.now() - state.startedAt) / 1000) : 0;
        stageT('result_shown');
        funnel('result_shown', { waited_s: waited, seconds: Math.round(state.resultSeconds), shots });
        window.__aeToolComplete && window.__aeToolComplete({ slug: SLUG, seconds: Math.round(state.resultSeconds), waited_s: waited });
        if (draft && state.sessionIds.has(data.id)) draft.done();
    }
}

/* ══════════════════════════════════════════ ПЕСНЯ КЛИПА И ПЕРЕСЪЁМКА ══ */

/**
 * Песня клипа — на наш сервер, чтобы выданный файл нёс музыку сам
 * (App\Services\AiVideo\ClipSong, решение Фарида 27.10.2026). До этого музыку
 * клала только эта вкладка при «Скачать», а уйти, пока клип рисуется, страница
 * разрешает: из 7 человек с клипом под песню 24–26.10 файл с музыкой получил
 * один. Шлём сразу после запуска и ещё раз, если человек вернулся к немому
 * клипу со своей песней. Порциями — общая дверь (__uploadFetch). Сервер
 * сверяет длину с той, под которую резали клип; повтор безвреден.
 */
async function sendSong(id) {
    const key = String(id || '');
    if (!key || !state.song || !state.song.file || state.songSent.has(key)) return;
    state.songSent.add(key);
    const file = state.song.file;
    const url = U.song + '/' + encodeURIComponent(key);
    const init = { method: 'POST', credentials: 'same-origin',
        headers: { 'X-CSRF-TOKEN': csrf(), 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/json' } };
    const t0 = performance.now();
    for (let attempt = 0; attempt < 3; attempt++) {
        const fd = new FormData();
        fd.append('audio', file, file.name || 'song');
        let res = null, data = null;
        try {
            res = window.__uploadFetch ? await window.__uploadFetch(url, fd, init) : await fetch(url, Object.assign({ body: fd }, init));
            try { data = await res.json(); } catch (_) { /* разберём по статусу */ }
        } catch (_) { res = null; }
        if (res && res.ok && data && data.ok) {
            funnel('song_sent', { id: key, mb: Math.round(file.size / 1048576), ms: Math.round(performance.now() - t0), tries: attempt + 1 });
            return;
        }
        // Отказ по существу (чужая длина, нечитаемый файл) — повтор не поможет.
        if (res && res.status >= 400 && res.status < 500 && res.status !== 408 && res.status !== 429) {
            funnel('song_refused', { id: key, status: res.status, err: (data && data.error) || '' });
            return;
        }
        await new Promise((r) => setTimeout(r, 4000 * (attempt + 1)));
    }
    state.songSent.delete(key);
    funnel('song_send_failed', { id: key });
}

/** Та же ли песня загружена, что у клипа (имя может отличаться — сверка по длине). */
function songMatches(meta) {
    if (!meta || !state.song || !(+meta.dur > 0)) return false;
    return Math.abs(state.song.duration - +meta.dur) < 0.6;
}

/** Всё, что у показанного клипа зависит от песни, слов и пересъёмки. */
function refreshResultSong() {
    const isResult = state.shown === 'result';
    const has = !!(state.resultHasSong || state.serverAudio);
    const ls = lyrState();
    $('cgDownloadSilent') && ($('cgDownloadSilent').hidden = !has);
    paintMore();
    const dlab = $('cgDownloadLabel');
    if (dlab) {
        dlab.textContent = (has && !state.canvas)
            ? ((ls.shown ? I.download_with_lyrics : '') || I.download_with_music || I.download || '')
            : (I.download || '');
    }
    const hint = $('cgSongHint');
    if (hint) {
        const need = isResult && !has && !!state.resultSong;
        hint.hidden = !need;
        if (need) hint.textContent = tr('song_reattach', { name: state.resultSong.name || '…' });
    }
    const rb = $('cgRedo');
    if (rb) rb.hidden = !(isResult && state.resultScenes.length > 1 && (state.canRedo || state.redoWhy === 'cover_gone'));
    paintSinger(isResult && state.resultScenes.length > 0, state.singWhy, state.proUrl);
    setOverlay(isResult && has);
}

/** Сцена клипа, которую показывает ролик сейчас. */
function sceneAtVideo() {
    const v = $('cgVideo');
    const t = v ? (v.currentTime || 0) : 0;
    let k = 0;
    state.resultScenes.forEach((sc, i) => { if (t + 0.02 >= sc[0]) k = i; });
    return k;
}
/* Границы сцены — с десятыми, если склейка не на целой секунде: сцена
   4.83–9.67 с выглядела «0:05–0:10» (прод-прогон 27.10), и человек не видел,
   что переснимет и последние кадры перед «0:05». */
function fmtSceneT(t) {
    if (Math.abs(t - Math.round(t)) < 0.05) return fmtClock(t);
    const m = Math.floor(t / 60), sec = t - m * 60;
    let s = sec.toFixed(1);
    try { s = sec.toLocaleString(window.__intlLocale ? window.__intlLocale() : undefined, { minimumFractionDigits: 1, maximumFractionDigits: 1, minimumIntegerDigits: 2 }); } catch (_) { /* toFixed остаётся */ }
    return m + ':' + (sec < 10 && !/^\d{2}/.test(s) ? '0' + s : s);
}
function redoTokens(secs) {
    return (+REDO.base || 0) + Math.round(Math.ceil(Math.max(1, secs)) * (+REDO.per || 0));
}
/* Пачка пересъёмки (29.10.2026): сцена → её описание. Открытие отмечает сцену
   под плеером; правка описания другой сцены отмечает и её; «＋/✓ В пересъёмку»
   — вручную. Без пачки (выключатель) отмечена всегда одна — текущая. */
const redoPick = new Map();
const redoPrefillOf = (k) => state.resultShotsSrc[k] || state.resultPrompt || '';
const redoPicked = () => [...redoPick.keys()].sort((a, b) => a - b);
function redoSecs(ks) {
    return ks.reduce((t, k) => { const sc = state.resultScenes[k]; return t + (sc ? sc[1] - sc[0] : 0); }, 0);
}
function redoPickOnly(k) { redoPick.clear(); redoPick.set(k, redoPrefillOf(k)); }
function paintRedo() {
    const k = state.redoScene, sc = state.resultScenes[k];
    if (!sc) return;
    if (!REDO.multi && !redoPick.has(k)) redoPickOnly(k);
    const head = $('cgRedoScene');
    if (head) head.textContent = tr('redo_scene', { n: k + 1, total: state.resultScenes.length, from: fmtSceneT(sc[0]), to: fmtSceneT(sc[1]) });
    const inp = $('cgRedoIn');
    if (inp) inp.value = redoPick.has(k) ? redoPick.get(k) : redoPrefillOf(k);
    const ks = redoPicked();
    const batch = $('cgRedoBatch');
    if (batch) batch.hidden = !REDO.multi;
    const pick = $('cgRedoPick');
    if (pick) pick.setAttribute('aria-pressed', redoPick.has(k) ? 'true' : 'false');
    const list = $('cgRedoPicked');
    if (list) {
        list.textContent = '';
        if (ks.length > 1) {
            ks.forEach((s) => {
                const b = document.createElement('button');
                b.type = 'button';
                b.className = 'cg-redo-chip';
                b.textContent = String(s + 1);
                if (s === k) b.setAttribute('aria-current', 'true');
                b.addEventListener('click', () => stepRedo(s - state.redoScene));
                list.append(b);
            });
        }
    }
    const label = $('cgRedoGoLabel');
    if (label) label.textContent = ks.length > 1 ? tr('redo_go_n', { n: ks.length }) : (I.redo_go || '');
    const secs = redoSecs(ks);
    const tokens = ks.length ? redoTokens(secs) : 0;
    const price = $('cgRedoPrice');
    if (price) price.textContent = ks.length ? fmtNum(tokens) : '';
    const note = $('cgRedoNote');
    const go = $('cgRedoGo');
    if (state.redoWhy === 'cover_gone') {
        if (note) note.textContent = I.redo_why_cover_gone || '';
        if (go) go.disabled = true;
    } else {
        const money = moneyFor(tokens);
        if (note) note.textContent = ks.length > 1 ? tr('redo_picked', { list: ks.map((s) => s + 1).join(', ') }) + ' ' : '';
        if (note) note.textContent += tr('redo_note', { n: fmtMin(COLD_START_S + secs * REALTIME_FACTOR) }) + (money ? ' ' + tr('cost_money', { n: money }) : '');
        if (go) go.disabled = state.busy || !ks.length;
    }
    $('cgRedoPrev') && ($('cgRedoPrev').disabled = k <= 0);
    $('cgRedoNext') && ($('cgRedoNext').disabled = k >= state.resultScenes.length - 1);
}
function stepRedo(d) {
    const k = Math.max(0, Math.min(state.resultScenes.length - 1, state.redoScene + d));
    if (k === state.redoScene) return;
    state.redoScene = k;
    if (!REDO.multi) redoPickOnly(k);
    const v = $('cgVideo');
    // Ролик встаёт на эту сцену — человек видит, что переснимает.
    if (v && state.resultScenes[k]) { try { v.currentTime = state.resultScenes[k][0] + 0.05; } catch (_) { /* — */ } }
    paintRedo();
}
function redoToggle() {
    const k = state.redoScene;
    if (redoPick.has(k)) {
        redoPick.delete(k);
    } else if (redoPick.size >= (+REDO.max || 12)) {
        msg(tr('redo_max', { n: +REDO.max || 12 }), 'warn');
        return;
    } else {
        redoPick.set(k, (($('cgRedoIn') || {}).value || '').trim() || redoPrefillOf(k));
    }
    funnel('redo_pick', { scene: k, on: redoPick.has(k) ? 1 : 0, n: redoPick.size });
    paintRedo();
}
function redoTyped() {
    const k = state.redoScene;
    const text = (($('cgRedoIn') || {}).value || '');
    // Правка описания — это и есть «переснять эту сцену».
    if (!redoPick.has(k) && redoPick.size >= (+REDO.max || 12)) return;
    const was = redoPick.size;
    redoPick.set(k, text);
    if (redoPick.size !== was) paintRedo();
}
function redoWhyText(why) {
    if (why === 'cover_gone') return I.redo_why_cover_gone || '';
    if (why === 'expired') return I.redo_why_expired || '';
    return I.error_generic || '';
}
async function submitRedo() {
    if (state.busy || !state.lastId) return;
    if (!state.authed) { handleRefusal(401, { error: 'auth' }, 'redo'); return; }
    const ks = redoPicked();
    if (!ks.length) return;
    const k = ks[0], sc = state.resultScenes[k];
    if (!sc) return;
    // Описание уходит, только если его правили: иначе сервер берёт прежнее
    // (уже переведённое) и не переводит его второй раз.
    const edited = (s) => { const t = String(redoPick.get(s) || '').trim(); return t && t !== redoPrefillOf(s).trim() ? t : ''; };
    const body = { of: state.lastId };
    if (ks.length === 1) {
        body.scene = k;
        if (edited(k)) body.prompt = edited(k);
    } else {
        body.scenes = ks;
        body.prompts = {};
        ks.forEach((s) => { if (edited(s)) body.prompts[s] = edited(s); });
    }
    const secs = redoSecs(ks);
    listenStop();
    setBusy(true);
    const go = $('cgRedoGo');
    if (go) go.disabled = true;
    funnel('redo_start', { scene: k, n: ks.length, secs: Math.round(secs), own: ks.filter((s) => edited(s)).length, tokens: redoTokens(secs) });
    const { res, data } = await post(U.redo, body);
    if (!res.ok || !data || !data.ok) {
        setBusy(false);
        if (go) go.disabled = false;
        handleRefusal(res.status, data, 'redo');
        return;
    }
    closePop('cgPopRedo');
    const of = state.lastId;
    state.id = data.id;
    state.sessionIds.add(data.id);
    state.waitKind = 'redo';
    state.queue = null;
    state.startedAt = Date.now();
    state.etaS = COLD_START_S + secs * REALTIME_FACTOR + 30;
    state.genSong = false;
    if (typeof data.balance === 'number') setBalance(data.balance);
    try { window.__pendingJobAttached = { tool: SLUG, id: String(data.id) }; } catch (_) { /* — */ }
    libPrepend({ id: data.id, status: 'queued', prompt: state.resultPrompt, created_at: new Date().toISOString(),
        clip: { redo: Object.assign({ of, scene: k }, ks.length > 1 ? { scenes: ks } : {}) } });
    lyrAttachTo(data.id);
    startWaiting(I.phase_redo || I.generating || '');
    msg('');
    poll();
}
function bindRedo() {
    const pop = $('cgPopRedo');
    if (!pop) return;
    const open = () => {
        const v = $('cgVideo');
        if (v && !v.paused) v.pause();
        state.redoScene = sceneAtVideo();
        redoPickOnly(state.redoScene);
        paintRedo();
        funnel('redo_open', { scene: state.redoScene, scenes: state.resultScenes.length, why: state.redoWhy });
    };
    pop.addEventListener('toggle', (e) => { if (e.newState === 'open') open(); });
    // Без Popover API модуль открывает панель сам — подготовить её тем же входом.
    $('cgRedo') && $('cgRedo').addEventListener('click', () => { if (!('popover' in HTMLElement.prototype)) open(); });
    $('cgRedoPrev') && $('cgRedoPrev').addEventListener('click', () => stepRedo(-1));
    $('cgRedoNext') && $('cgRedoNext').addEventListener('click', () => stepRedo(1));
    $('cgRedoGo') && $('cgRedoGo').addEventListener('click', submitRedo);
    $('cgRedoPick') && $('cgRedoPick').addEventListener('click', redoToggle);
    $('cgRedoIn') && $('cgRedoIn').addEventListener('input', redoTyped);
}

/* ── черновик описаний по тексту песни (ClipSceneDraft, 29.10.2026) ──
   Модель пишет описание каждой ПУСТОЙ части — повторы отдельно, поэтому
   разные куплеты под одной буквой получают разные картинки. Описанное
   человеком не трогается: черновик заполняет только пустое. */
function draftTargets() {
    return boardModel().parts.filter((p) => !String(p.unlinked ? p.occText : p.text || '').trim());
}
function paintDraft() {
    const b = $('cgSbDraft');
    if (!b) return;
    b.hidden = !DRAFT.enabled || !boardModel().parts.some((p) => p.lyric);
    if (b.hidden) return;
    const left = draftTargets().length;
    b.disabled = draftBusy || state.busy || !left;
    b.title = left ? (I.draft_title || '') : (I.draft_nothing || '');
    const pr = $('cgSbDraftPrice');
    if (pr) pr.textContent = fmtNum(+DRAFT.tokens || 0);
}
async function runDraft() {
    if (draftBusy || state.busy) return;
    if (!state.authed) { handleRefusal(401, { error: 'auth' }, 'draft'); return; }
    const targets = draftTargets();
    if (!targets.length) { msg(I.draft_nothing || '', 'warn'); return; }
    draftBusy = true;
    paintDraft();
    msg(I.draft_busy || '');
    const t0 = Date.now();
    const look = state.look && state.look !== 'plain' ? state.look : '';
    const from = state.song ? state.win.from : 0;
    const { res, data } = await post(U.draft, {
        parts: targets.map((p) => ({ label: p.label,
            lyric: lyrTextStarting(Math.max(p.t0, from), Math.min(p.t1, from + state.seconds)) || p.lyric })),
        idea: (($('cgPrompt') || {}).value || '').trim(), look, lang: window.__LOCALE || 'ru',
    });
    draftBusy = false;
    if (!res.ok || !data || !data.ok) {
        paintDraft();
        if (data && (data.error === 'provider' || data.error === 'no_lyrics')) msg(I.draft_failed || '', 'warn');
        else handleRefusal(res.status, data, 'draft');
        return;
    }
    if (typeof data.balance === 'number') setBalance(data.balance);
    let n = 0;
    targets.forEach((p, j) => {
        const text = String((data.texts || [])[j] || '').trim();
        if (!text) return;
        if (p.repeats > 1) {
            if (!p.unlinked) unlinkOcc(p.t0);
            setOccText(p.t0, text);
        } else {
            state.partText[p.label] = text;
        }
        n++;
    });
    paintTimeline();
    funnel('scene_draft', { n, parts: targets.length, ms: Date.now() - t0 });
    msg(tr('draft_done', { n }));
}

/* ── раскадровка карточками и её кадры (board.js) ── */
function bindBoard() {
    const SB = CG.storyboard || { enabled: false };
    mountBoard({
        I, tr, U, fmtNum, post,
        fmtSpan: (a, b) => fmtSceneT(a) + '–' + fmtSceneT(b),
        model: boardModel, compositionSig,
        select: (sel, from) => select(sel, from),
        isSelectedScene: (i) => !!(state.selected && state.selected.kind === 'scene' && state.selected.index === i),
        selectedScene: () => (state.selected && state.selected.kind === 'scene') ? state.selected.index : null,
        setSceneText: (i, t) => { setSceneText(i, t); paintTimeline(); },
        setPartText: (l, t) => { state.partText[l] = t; paintTimeline(); },
        setOccText, isUnlinked, linkOcc, unlinkOcc, setSceneSeed,
        winFrom: () => (state.song ? state.win.from : 0),
        price: (n) => Math.max(1, (+SB.base || 0) + Math.max(0, n) * (+SB.per || 0)),
        canRequest: () => !!SB.enabled && !state.busy && state.cuts.length > 0,
        authed: () => state.authed,
        payload: (extra) => { const pr = needPrompt(); return pr ? payload(pr, extra) : null; },
        setBalance, funnel,
        onRefusal: (st, data) => handleRefusal(st, data, 'storyboard'),
        onStills: () => {},
        showStill: showStillOnStage,
    });
}

/* ── поющий персонаж (singer.js) ── */
/** Ожидание версии с певцом: сцены у вендора параллельно — решает самая длинная. */
function singerEta(ks) {
    const longest = (ks || []).reduce((m, k) => {
        const sc = state.resultScenes[k];
        return sc ? Math.max(m, sc[1] - sc[0]) : m;
    }, 0);
    return (+SINGER.base_s || 120) + (+SINGER.s_per_s || 30) * Math.max(+SINGER.min_s || 4, longest) + 30;
}
const ASPECT_WH = { vertical: [9, 16], wide: [16, 9], square: [1, 1] };
function bindSinger() {
    if (!SINGER.enabled) return;
    mountSinger({
        I, tr, cfg: SINGER, U, csrf, fmtClock, fmtNum, fmtMin, moneyFor, funnel,
        getScenes: () => state.resultScenes,
        getAspect: () => ASPECT_WH[state.resultAspect] || ASPECT_WH.vertical,
        getClipId: () => state.lastId,
        sceneAtVideo,
        seekTo: (t) => { const v = $('cgVideo'); if (v) { if (!v.paused) v.pause(); try { v.currentTime = t; } catch (_) { /* — */ } } },
        isBusy: () => state.busy,
        getAuthed: () => state.authed,
        onRefusal: (st, data) => handleRefusal(st, data, 'singer'),
        onStarted: (data, scenes) => {
            closePop('cgPopSinger');
            const of = state.lastId;
            listenStop();
            setBusy(true);
            state.id = data.id;
            state.sessionIds.add(data.id);
            state.waitKind = 'singer';
            state.queue = null;
            state.startedAt = Date.now();
            state.etaS = singerEta(scenes);
            state.genSong = false;
            if (typeof data.balance === 'number') setBalance(data.balance);
            try { window.__pendingJobAttached = { tool: SLUG, id: String(data.id) }; } catch (_) { /* — */ }
            libPrepend({ id: data.id, status: 'queued', prompt: state.resultPrompt, created_at: new Date().toISOString(), clip: { singer: { of, scenes } } });
            lyrAttachTo(data.id);
            startWaiting(I.phase_singer || I.generating || '');
            msg('');
            poll();
        },
    });
}

/* ── возврат к идущей генерации (ушёл со страницы и вернулся) ── */
function attachRunning(item) {
    state.id = item.id;
    state.waitKind = (item.clip && item.clip.singer) ? 'singer' : (item.clip && item.clip.redo) ? 'redo' : 'clip';
    state.queue = null;
    state.startedAt = item.created_at ? Date.parse(item.created_at) : Date.now();
    const secs = (item.clip && item.clip.seconds) || 180;
    state.resultSeconds = secs;
    state.etaS = state.waitKind === 'singer' ? singerEta(item.clip.singer.scenes || []) : COLD_START_S + secs * REALTIME_FACTOR;
    state.genSong = false;
    // Песня идущего клипа: если она на странице (черновик вернул её, выбрали
    // снова) — отправить; запуск мог уйти раньше, чем песня успела доехать.
    state.runningSong = (item.clip && item.clip.song) || null;
    if (songMatches(state.runningSong)) sendSong(item.id);
    setBusy(true);
    try { window.__pendingJobAttached = { tool: SLUG, id: String(item.id) }; } catch (_) { /* — */ }
    startWaiting(I.generating || '');
    msg(I.resumed || '', '');
    funnel('resumed', { id: item.id });
    poll();
}

async function openFromLibrary(item) {
    if (state.busy && item.id !== state.id) { msg(I.generating || '', ''); return; }
    if (item.status === 'queued' || item.status === 'running') { if (!state.busy) attachRunning(item); return; }
    if (item.status !== 'done') return;
    try {
        const r = await fetch(U.status + '/' + item.id, { headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, credentials: 'same-origin' });
        const d = await r.json();
        if (d && d.status === 'done') {
            state.resultFrom = 0;
            deliver(d, state.sessionIds.has(item.id) && item.id === state.id);
            funnel('lib_open', { id: item.id });
        }
    } catch (_) { /* сеть — плитка просто не открылась */ }
}

/* ── проба сцены ── */
async function preview() {
    if (state.busy) return;
    const prompt = needPrompt();
    if (!prompt) return;
    if (!state.authed) { handleRefusal(401, { error: 'auth' }, 'preview'); return; }
    listenStop();
    setBusy(true);
    msg('');
    state.startedAt = Date.now();
    state.etaS = PREVIEW_ETA_S;
    startWaiting(I.preview_running || '', true);
    stageHead(I.preview_title || '', I.preview_badge || '');
    stageT('preview_start');
    funnel('preview_start', { tokens: PRICE.preview || 0, look: state.look, style: state.style, aspect: state.aspect });
    const { res, data } = await post(U.preview, { prompt, style: state.style, look: state.look, aspect: state.aspect });
    if (!res.ok || !data || !data.ok) {
        setBusy(false);
        hideProgress();
        showGallery();
        handleRefusal(res.status, data, 'preview');
        return;
    }
    if (typeof data.balance === 'number') setBalance(data.balance);
    pollPreview(data.job);
}

function pollPreview(job) {
    clearInterval(state.timer);
    let tries = 0;
    state.timer = setInterval(async () => {
        tickProgress(I.preview_running || '');
        if (++tries > 60) {
            clearInterval(state.timer);
            setBusy(false); status('');
            hideProgress(); showGallery();
            msg(I.preview_failed || I.error_generic, 'bad');
            critical('clip_preview_timeout', {});
            return;
        }
        let d = null;
        try {
            const r = await fetch(U.preview + '/' + encodeURIComponent(job), { headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, credentials: 'same-origin' });
            d = await r.json();
        } catch (_) { return; }
        if (!d || d.status === 'running') return;
        clearInterval(state.timer);
        setBusy(false);
        status('');
        if (typeof d.balance === 'number') setBalance(d.balance);
        if (d.status !== 'done' || !d.url) {
            hideProgress(); showGallery();
            msg(I.preview_failed || I.error_generic, 'bad');
            critical('clip_preview_failed', { error: d && d.error, refunded: !!(d && d.refunded) });
            return;
        }
        stageHead(I.preview_title || '', I.preview_badge || '');
        showVideo(d.url, 'preview');
        msg(tr('preview_done', { len: fmtClock(state.seconds), n: state.cuts.length }), '');
        stageT('preview_shown');
        funnel('preview_shown', { waited_s: Math.round((Date.now() - state.startedAt) / 1000), charged: d.charged || 0 });
    }, 3000);
}

/* ══════════════════════════════════════════════════════ СКАЧИВАНИЕ ══ */

async function saveBlob(blob, name) {
    if (window.__downloadFile) return window.__downloadFile(blob, name);
    const a = document.createElement('a');
    a.href = URL.createObjectURL(blob);
    a.download = name;
    a.click();
    return true;
}
function outName(suffix) {
    const base = state.song && state.song.name ? state.song.name.replace(/\.[^.]+$/, '') : 'clip';
    const safe = (window.__outputName && window.__outputName.sanitize) ? window.__outputName.sanitize(base) : base;
    return (safe || 'clip') + (suffix || '') + '.mp4';
}
async function fetchClip() {
    const res = await fetch(state.lastUrl, { credentials: 'same-origin' });
    if (!res.ok) throw new Error('clip-fetch-' + res.status);
    return res.blob();
}
/**
 * Клип со звуком и словами (один раз на результат и набор слов: скачать и
 * поделиться — тот же файл). Сначала слова В КАДРЫ (burn.js — тот же
 * художник, что предпросмотр), потом музыка (mux.js, общий VideoAudioLane).
 */
async function withMusic() {
    const ls = lyrState();
    const burn = !!((state.resultHasSong || state.serverAudio) && ls.shown);
    const sig = state.lastId + '|' + (burn ? JSON.stringify(linesForTimeline()) + ls.mode + ls.pos : '-') + '|' + state.resultFrom;
    if (state.outBlob && state.outSig === sig) return state.outBlob;
    let clip = await fetchClip();
    if (!state.serverAudio && (!state.resultHasSong || !state.song)) return clip;
    if (burn) {
        const { burnLyrics } = await import('./burn.js');
        await lyrLibs();
        const from = state.resultFrom;
        try {
            const b = await burnLyrics(clip, {
                draw: (g, w, h, t) => drawLyrics(g, w, h, from + t),
                onProgress: (f) => { const pct = Math.round(100 * f); status(tr('lyr_burning', { pct })); msg(tr('lyr_burning', { pct }), ''); },
            });
            if (b) { clip = b; funnel('lyrics_burned', { lines: ls.count, mode: ls.mode }); }
            else { msg(I.lyr_burn_failed || '', 'warn'); funnel('lyrics_burn_skipped', { why: 'no_pipeline' }); }
        } catch (e) {
            msg(I.lyr_burn_failed || '', 'warn');
            critical('clip_lyrics_burn_failed', { msg: String((e && e.message) || e).slice(0, 80) });
        }
    }
    // Музыка уже в файле (сведена на сервере): слова легли поверх с его же
    // звуком (burn.js проносит дорожку), класть песню второй раз не нужно.
    if (state.serverAudio) {
        status('');
        state.outBlob = clip;
        state.outSig = sig;
        return clip;
    }
    status(I.muxing || '');
    msg(I.muxing || '', '');
    const { muxAudio } = await import('./mux.js');
    const out = await muxAudio(clip, {
        buffer: state.buffer, songFile: state.song.file,
        from: state.resultFrom, seconds: state.resultSeconds, laneUrl: U.audioLane,
    });
    status('');
    if (!out) {
        msg(I.mux_failed || '', 'warn');
        critical('clip_mux_failed', {});
        return clip;
    }
    msg('');
    funnel('mux', { lane: out.lane });
    state.outBlob = out.blob;
    state.outSig = sig;
    return out.blob;
}

async function download() {
    if (!state.lastUrl) return;
    const btn = $('cgDownload');
    if (btn) btn.disabled = true;
    try {
        const silentCanvas = state.canvas;
        // Музыка в файле и слов поверх нет — отдать файл сервера ссылкой: без
        // 100–150 МБ в памяти вкладки (дверь своих файлов, __downloadLink).
        const linkOnly = state.serverAudio && !lyrState().shown && window.__downloadLink;
        if (linkOnly) {
            window.__downloadLink(silentCanvas ? state.lastUrl + '?dl=1&silent=1' : (state.lastDl || state.lastUrl + '?dl=1'), outName(silentCanvas ? '-canvas' : ''));
            funnel('download', { music: silentCanvas ? 0 : 1, canvas: silentCanvas ? 1 : 0, server: 1 });
            stageT('downloaded');
            return;
        }
        const blob = silentCanvas ? await fetchClip() : await withMusic();
        await saveBlob(blob, outName(silentCanvas ? '-canvas' : ''));
        funnel('download', { music: (!silentCanvas && state.resultHasSong) ? 1 : 0, canvas: silentCanvas ? 1 : 0 });
        stageT('downloaded');
    } catch (e) {
        msg(I.mux_failed || I.error_generic, 'warn');
        window.location.href = state.lastUrl + (state.lastUrl.includes('?') ? '&' : '?') + 'dl=1';
    } finally {
        if (btn) btn.disabled = false;
    }
}
async function downloadSilent() {
    if (!state.lastUrl) return;
    const btn = $('cgDownloadSilent');
    if (btn) btn.disabled = true;
    try {
        // В файле есть музыка — немую копию делает сервер (дорожка картинки копией).
        if (state.serverAudio && window.__downloadLink) {
            window.__downloadLink(state.lastUrl + '?dl=1&silent=1', outName('-silent'));
            funnel('download', { music: 0, server: 1 });
            stageT('downloaded');
            return;
        }
        await saveBlob(await fetchClip(), outName('-silent'));
        funnel('download', { music: 0 });
        stageT('downloaded');
    } catch (_) {
        window.location.href = state.lastUrl + (state.lastUrl.includes('?') ? '&' : '?') + 'dl=1';
    } finally {
        if (btn) btn.disabled = false;
    }
}
async function share() {
    if (!state.lastUrl || !navigator.share) return;
    try {
        const blob = state.canvas ? await fetchClip() : await withMusic();
        const file = new File([blob], outName(''), { type: 'video/mp4' });
        await navigator.share({ files: [file] });
        funnel('share', { ok: 1 });
    } catch (e) {
        if (e && e.name === 'AbortError') return;
        msg(I.share_failed || '', 'warn');
        funnel('share', { ok: 0 });
    }
}

/* ══════════════════════════════════════════════════════ ЗАГРУЗКА ═════ */

async function bootstrap() {
    try {
        const r = await fetch(U.bootstrap, { headers: { Accept: 'application/json' }, credentials: 'same-origin' });
        const b = await r.json();
        state.live = !!(b.enabled_map && b.enabled_map[SLUG]);
        state.authed = !!b.authed;
        state.pro = !!b.pro;
        if (b.money && b.money.rate > 0) state.money = b.money;
        if (typeof b.balance === 'number') state.balance = b.balance;
        state.locked = Math.max(0, +b.balance_locked || 0);
        if (!state.live) msg(I.coming_soon, '');
        document.querySelectorAll('[data-perk-badge]').forEach((el) => { el.hidden = state.pro; });
        funnel('bootstrap', { authed: state.authed ? 1 : 0, live: state.live ? 1 : 0, bal: state.balance, pro: state.pro ? 1 : 0 });
    } catch (_) {
        // Сеть недоступна — отказ придёт от сервера при нажатии.
    }
    // Качество Премиума у не-Премиума не восстанавливаем из памяти.
    if (!state.pro) {
        if (state.res >= 1080) { state.res = 720; radio($('cgRes'), 'res', 720); }
        if (state.fps >= 24) { state.fps = 12; radio($('cgFps'), 'fps', 12); }
    }
    refreshPills();
    refreshCost();
    if (state.authed) {
        const items = await loadLibrary();
        const want = new URLSearchParams(location.search).get('job');
        const target = want ? items.find((x) => String(x.id) === String(want)) : null;
        const running = items.find((x) => (x.status === 'queued' || x.status === 'running')
            && x.created_at && (Date.now() - Date.parse(x.created_at)) < 60 * 60 * 1000);
        if (target) openFromLibrary(target);
        else if (running && !state.busy) attachRunning(running);
    }
}

function restoreSettings() {
    const pickBtn = (sel) => document.querySelector(sel);
    const st = load('style', null);
    if (st && pickBtn('#cgStyle [data-style="' + CSS.escape(String(st)) + '"]')) pickStyle(String(st), true);
    const lk = load('look', null);
    if (lk && pickBtn('#cgLook [data-look="' + CSS.escape(String(lk)) + '"]')) pickLook(String(lk), true);
    const asp = load('aspect', null);
    const ab = asp && pickBtn('#cgAspect [data-aspect="' + CSS.escape(String(asp)) + '"]');
    if (ab) pickAspect(ab, true);
    const rc = load('react', null);
    if (rc !== null && CG.motion && pickBtn('#cgMotion [data-react="' + CSS.escape(String(rc)) + '"]')) {
        state.react = +rc; radio($('cgMotion'), 'react', String(rc));
    }
    const rs = load('res', null);
    if (rs && CG.hd) { state.res = +rs; radio($('cgRes'), 'res', String(rs)); }
    const fp = load('fps', null);
    if (fp && CG.smooth) { state.fps = +fp; radio($('cgFps'), 'fps', String(fp)); }
}

function init() {
    const app = $('cgApp');
    if (!app) return;
    const onBtn = (sel, attr) => { const b = document.querySelector(sel); return b ? b.dataset[attr] : null; };
    state.style = onBtn('#cgStyle .cg-opt.on', 'style') || 'flow';
    state.look = onBtn('#cgLook .cg-look.on', 'look') || 'plain';
    const ab = document.querySelector('#cgAspect .cg-opt.on') || document.querySelector('#cgAspect .cg-opt');
    if (ab) pickAspect(ab, true);
    restoreSettings();

    bindChoices();
    bindExamples();
    bindPlayOverlay();

    mountTimeline({
        i18n: I,
        onSelect: (sel) => select(sel),
        onWindow: (w, final) => { if (state.song) setWindow(w.from, w.to, 'custom', final); if (final) funnel('window_drag', { s: Math.round(state.seconds) }); },
    });
    mountLibrary({ i18n: I, urls: U, onPick: openFromLibrary });
    mountLyrics({
        i18n: I,
        urls: { lyricsLibs: U.lyricsLibs, alignLibs: U.alignLibs, lyrics: U.lyrics, sepMb: CG.sepMb },
        hooks: {
            song: () => (state.song && state.buffer) ? { buffer: state.buffer, duration: state.song.duration, name: state.song.name || '' } : null,
            // Чьи это слова: клипа, который рисуется под эту песню, или
            // показанного клипа этой песни. Иначе — ничьи (до сборки).
            target: () => {
                if (state.busy && state.id && state.genSong) return state.id;
                if (state.shown === 'result' && state.resultHasSong && state.lastId) return state.lastId;
                return null;
            },
            onChange: () => { refreshPills(); paintTimeline(); if (state.shown === 'result') refreshResultSong(); state.outBlob = null; },
            funnel, save, load,
        },
    });
    attachOverlay($('cgVideo'), $('cgLyrOverlay'), () => state.resultFrom);
    bindRedo();
    bindSinger();
    bindBoard();
    $('cgSbDraft') && $('cgSbDraft').addEventListener('click', runDraft);

    $('cgListen') && $('cgListen').addEventListener('click', () => {
        if (audioEl && !audioEl.paused && audioEl.dataset.mode === 'listen') listenStop(); else listenStart();
    });

    // Песня приезжает уже декодированной (общий аплоадер → AudioDecoderRobust).
    // ⚠️ Гонка привязки: модуль мог привязаться ПОЗЖЕ выбора файла — примитив
    // отдаёт пик опоздавшему, а декодируем тогда сами.
    const zone = $('cgSong');
    if (zone) {
        let replaying = true;
        zone.addEventListener('tool-uploader:decoded', (e) => onSong(e.detail && e.detail.file, e.detail && e.detail.buffer));
        if (window.__bindUploaderFile) {
            window.__bindUploaderFile(zone, async (file, detail) => {
                if (!replaying) return;
                if (detail && detail.buffer) { onSong(file, detail.buffer); return; }
                try {
                    const ctx = new (window.AudioContext || window.webkitAudioContext)();
                    const r = window.AudioDecoderRobust ? await window.AudioDecoderRobust.robust(file, ctx, { slug: SLUG }) : null;
                    onSong(file, (r && (r.buffer || r)) || null);
                } catch (_) { msg(I.song_failed || I.error_generic, 'warn'); }
            });
        }
        Promise.resolve().then(() => { replaying = false; });
        zone.addEventListener('tool-uploader:clear', dropSong);
    }
    const imgZone = $('cgImage');
    if (imgZone) {
        if (window.__bindUploaderFile) window.__bindUploaderFile(imgZone, (file) => onImage(file));
        else imgZone.addEventListener('tool-uploader:file', (e) => onImage(e.detail && e.detail.file));
        imgZone.addEventListener('tool-uploader:clear', dropImage);
    }

    $('cgGo') && $('cgGo').addEventListener('click', run);
    $('cgPreview') && $('cgPreview').addEventListener('click', preview);
    $('cgAgain') && $('cgAgain').addEventListener('click', () => { showGallery(); msg(''); funnel('again', {}); });
    $('cgKeepSeed') && $('cgKeepSeed').addEventListener('click', () => {
        state.keepSeed = !state.keepSeed;
        $('cgKeepSeed').setAttribute('aria-pressed', state.keepSeed ? 'true' : 'false');
        msg(state.keepSeed ? (I.seed_kept || '') : (I.seed_released || ''), state.keepSeed ? 'good' : '');
        funnel('seed_kept', { on: state.keepSeed ? 1 : 0 });
    });
    $('cgDownload') && $('cgDownload').addEventListener('click', download);
    $('cgDownloadSilent') && $('cgDownloadSilent').addEventListener('click', downloadSilent);
    $('cgShare') && $('cgShare').addEventListener('click', share);
    // Пункт меню «⋯» сделал своё — меню закрывается («Тот же образ» — переключатель, меню остаётся).
    ['cgDownloadSilent', 'cgShare'].forEach((id) => $(id) && $(id).addEventListener('click', () => closePop('cgPopMore')));
    $('cgIdea') && $('cgIdea').addEventListener('click', nextIdea);

    const ta = $('cgPrompt');
    if (ta) ta.addEventListener('input', () => {
        if (!state.promptTyped && ta.value.trim().length >= 3) { state.promptTyped = true; stageT('prompt_typed'); funnel('prompt_typed', {}); }
        if (state.exPromptInserted && ta.value.trim() !== state.exPromptInserted) state.exPromptInserted = null;
        // Общее описание — подсказка у карточек сцен; доска появляется, когда есть что описывать.
        paintBoard();
        paintDraft();
    });

    state.shown = 'gallery';
    replan();
    stageT('open');
    bootstrap();
    draft = mountDraft({
        slug: SLUG, state, radio, replan, windowsFor, setWindow, funnel,
        pickLook: (k) => pickLook(k, true), pickStyle: (s) => pickStyle(s, true), pickAspect: (b) => pickAspect(b, true),
        clear: clearComposer,
        lyrics: { get: lyrExport, set: lyrImport },
        board: { get: exportStills, set: importStills },
    });
}

/** Пустой композер — для «＋ Новый клип» и перед возвратом сохранённой работы. */
function clearComposer() {
    listenStop();
    if (state.song && window.ToolUploader) window.ToolUploader.clear('cgSong');
    if (state.song) dropSong();
    if (state.image && window.ToolUploader) window.ToolUploader.clear('cgImage');
    if (state.image) dropImage();
    const ta = $('cgPrompt');
    if (ta) ta.value = '';
    $('cgExLine') && ($('cgExLine').hidden = true);
    state.promptTyped = false; state.exPromptInserted = null;
    state.partText = {}; state.sceneText = []; state.occText = []; state.sceneSeed = []; state.selected = null; state.canvas = false;
    clearStills();
    lyrClear();
    replan();
}

if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
else init();
